// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern FinStack Design System */
:root {
  /* Primary Colors - Modern blue with depth */
  --primary-50: #eff6ff;
  --primary-100: #dbeafe;
  --primary-200: #bfdbfe;
  --primary-300: #93c5fd;
  --primary-400: #60a5fa;
  --primary-500: #3b82f6;
  --primary-600: #2563eb;
  --primary-700: #1d4ed8;
  --primary-800: #1e40af;
  --primary-900: #1e3a8a;
  --primary-950: #172554;
  
  /* Legacy compatibility */
  --primary-color: var(--primary-500);
  --primary-dark: var(--primary-600);
  --primary-light: var(--primary-50);
  
  /* Semantic Colors - Enhanced with depth */
  --success-50: #f0fdf4;
  --success-100: #dcfce7;
  --success-200: #bbf7d0;
  --success-500: #22c55e;
  --success-600: #16a34a;
  --success-700: #15803d;
  --success-800: #166534;
  --success-color: var(--success-500);
  
  --danger-50: #fef2f2;
  --danger-100: #fee2e2;
  --danger-200: #fecaca;
  --danger-500: #ef4444;
  --danger-600: #dc2626;
  --danger-700: #b91c1c;
  --danger-800: #991b1b;
  --danger-color: var(--danger-500);
  
  --warning-50: #fffbeb;
  --warning-100: #fef3c7;
  --warning-200: #fde68a;
  --warning-500: #f59e0b;
  --warning-600: #d97706;
  --warning-700: #b45309;
  --warning-800: #92400e;
  --warning-color: var(--warning-500);
  
  /* Modern Gray Scale - Warmer and more sophisticated */
  --gray-50: #f9fafb;
  --gray-100: #f2f4f7;
  --gray-200: #e4e7ec;
  --gray-300: #d0d5dd;
  --gray-400: #98a2b3;
  --gray-500: #667085;
  --gray-600: #475467;
  --gray-700: #344054;
  --gray-800: #1d2939;
  --gray-900: #101828;
  --gray-950: #0c111d;
  
  /* Surface Colors */
  --surface-primary: #ffffff;
  --surface-secondary: var(--gray-50);
  --surface-tertiary: var(--gray-100);
  
  /* Border Colors */
  --border-light: var(--gray-200);
  --border-medium: var(--gray-300);
  --border-strong: var(--gray-400);
  
  /* Shadow System */
  --shadow-xs: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  --shadow-sm: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.10);
  --shadow-md: 0 2px 4px -2px rgba(16, 24, 40, 0.06), 0 4px 8px -2px rgba(16, 24, 40, 0.10);
  --shadow-lg: 0 4px 6px -2px rgba(16, 24, 40, 0.03), 0 10px 15px -3px rgba(16, 24, 40, 0.10);
  --shadow-xl: 0 8px 10px -3px rgba(16, 24, 40, 0.04), 0 20px 25px -5px rgba(16, 24, 40, 0.10);
  --shadow-2xl: 0 25px 50px -12px rgba(16, 24, 40, 0.25);
  
  /* Focus Ring */
  --focus-ring: 0 0 0 3px rgba(59, 130, 246, 0.12);
  --focus-ring-error: 0 0 0 3px rgba(239, 68, 68, 0.12);
  
  /* Gradients */
  --gradient-subtle: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);
  --gradient-primary: linear-gradient(135deg, var(--primary-500) 0%, var(--primary-600) 100%);
  
  /* Spacing Scale - 4px/8px grid */
  --space-1: 0.25rem;  /* 4px */
  --space-2: 0.5rem;   /* 8px */
  --space-3: 0.75rem;  /* 12px */
  --space-4: 1rem;     /* 16px */
  --space-5: 1.25rem;  /* 20px */
  --space-6: 1.5rem;   /* 24px */
  --space-8: 2rem;     /* 32px */
  --space-10: 2.5rem;  /* 40px */
  --space-12: 3rem;    /* 48px */
  --space-16: 4rem;    /* 64px */
  
  /* Border Radius */
  --radius-xs: 0.125rem;
  --radius-sm: 0.25rem;
  --radius-md: 0.375rem;
  --radius-lg: 0.5rem;
  --radius-xl: 0.75rem;
  --radius-2xl: 1rem;
  --radius-full: 9999px;
  
  /* Additional color variables for enhanced states */
  --primary-25: #f8faff;
  --success-25: #f7fef9;
  --danger-25: #fffbfa;
  --warning-25: #fffcf5;
  --gray-25: #fcfcfd;
  
  /* Enhanced shadow system */
  --shadow-focus: 0 0 0 3px rgba(59, 130, 246, 0.12);
  --shadow-focus-error: 0 0 0 3px rgba(239, 68, 68, 0.12);
  --shadow-focus-success: 0 0 0 3px rgba(34, 197, 94, 0.12);
  
  /* Animation timings */
  --duration-fast: 0.15s;
  --duration-normal: 0.2s;
  --duration-slow: 0.3s;
  --duration-slower: 0.5s;
  
  /* Easing functions */
  --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
  --ease-out: cubic-bezier(0, 0, 0.2, 1);
  --ease-in: cubic-bezier(0.4, 0, 1, 1);
  --ease-bounce: cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--surface-secondary);
  color: var(--gray-800);
  line-height: 1.6;
  letter-spacing: -0.01em;
}

/* Layout styles */
.app-container {
  display: flex;
  min-height: 100vh;
}

.sidebar {
  width: 250px;
  min-width: 250px;
  max-width: 250px;
  background-color: var(--surface-primary);
  border-right: 1px solid var(--border-light);
  display: none;
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@media (min-width: 768px) {
  .sidebar {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
  }
}

.sidebar-mobile {
  position: fixed;
  top: 0;
  left: 0;
  width: 250px;
  height: 100vh;
  background-color: var(--surface-primary);
  border-right: 1px solid var(--border-light);
  box-shadow: var(--shadow-lg);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  transform: translateX(-100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-mobile.sidebar-open {
  transform: translateX(0);
}

.sidebar-logo {
  padding: var(--space-4);
  border-bottom: 1px solid var(--border-light);
  font-weight: 700;
  font-size: 1.25rem;
  color: var(--primary-600);
  letter-spacing: -0.02em;
}

.sidebar-nav {
  flex: 1 1;
  padding: 1rem 0;
  overflow-y: auto;
}

.sidebar-nav-item {
  display: flex;
  align-items: center;
  padding: var(--space-3) var(--space-4);
  color: var(--gray-600);
  text-decoration: none;
  margin-bottom: var(--space-1);
  border-radius: var(--radius-md);
  margin-left: var(--space-2);
  margin-right: var(--space-2);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 500;
}

.sidebar-nav-item:hover {
  background-color: var(--gray-100);
  color: var(--gray-700);
  transform: translateX(2px);
}

.sidebar-nav-item.active {
  background-color: var(--primary-50);
  color: var(--primary-600);
  font-weight: 600;
  box-shadow: inset 3px 0 0 var(--primary-500);
}

.sidebar-nav-item svg {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.75rem;
}

.sidebar-footer {
  padding: var(--space-4);
  border-top: 1px solid var(--border-light);
}

/* Collapsed Sidebar Styles */
.sidebar-collapsed {
  width: 72px !important;
  min-width: 72px !important;
  max-width: 72px !important;
}
.sidebar-collapsed .sidebar-logo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-4);
}
.sidebar-collapsed .sidebar-logo .flex {
  justify-content: center;
  flex: 1 1;
}
.sidebar-collapsed .sidebar-nav-item {
  padding: var(--space-3) var(--space-4);
  justify-content: center;
  position: relative;
  margin-left: var(--space-1);
  margin-right: var(--space-1);
  min-height: 44px;
}
.sidebar-collapsed .sidebar-nav-item svg {
  margin-right: 0;
  width: 1.5rem;
  height: 1.5rem;
}
.sidebar-collapsed .sidebar-footer {
  padding: var(--space-3);
  display: flex;
  justify-content: center;
}
.sidebar-collapsed .sidebar-footer .flex {
  justify-content: center;
}

/* Tooltip for collapsed sidebar */
.sidebar-collapsed .sidebar-nav-item:hover::after {
  content: attr(title);
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  background-color: var(--gray-800);
  color: white;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  font-size: 0.875rem;
  white-space: nowrap;
  z-index: 1000;
  margin-left: var(--space-2);
  box-shadow: var(--shadow-lg);
  pointer-events: none;
}

/* Organization Switcher Styles */
.org-switcher-container {
  width: 100%;
  position: relative;
}

.org-switcher-container .dropdown-menu {
  max-width: 14rem;
  width: auto;
  background-color: #ffffff !important;
  border: 1px solid #e5e7eb !important;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}

.sidebar-collapsed .org-switcher-container .dropdown-menu {
  max-width: 12rem;
}

/* Ensure dropdown items are visible */
.org-switcher-container .dropdown-item {
  color: #374151 !important;
  background-color: transparent;
}

.org-switcher-container .dropdown-item:hover {
  background-color: #f3f4f6 !important;
}

/* Sidebar User Information Styles */
.sidebar-footer .btn {
  transition: all 0.2s ease-in-out;
}

.sidebar-footer .btn:hover {
  background-color: var(--gray-100);
  transform: translateY(-1px);
}

.sidebar-footer .btn:active {
  transform: translateY(0);
}

.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  margin-left: 250px;
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@media (max-width: 767px) {
  .main-content {
    margin-left: 0;
  }
}

.sidebar-collapsed ~ .main-content {
  margin-left: 72px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
}

.header {
  height: 64px;
  background-color: var(--surface-primary);
  border-bottom: 1px solid var(--border-light);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--space-4);
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: var(--shadow-sm);
  backdrop-filter: blur(8px);
}

.page-content {
  flex: 1 1;
  padding: var(--space-6);
}

/* Card styles */
.card {
  background-color: var(--surface-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-light);
  overflow: hidden;
  margin-bottom: var(--space-6);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}

.card-header {
  padding: var(--space-4) var(--space-5);
  border-bottom: 1px solid var(--border-light);
  font-weight: 600;
  font-size: 1.125rem;
  color: var(--gray-800);
  background: var(--gradient-subtle);
  letter-spacing: -0.01em;
}

.card-body {
  padding: var(--space-5);
}

.card-footer {
  padding: var(--space-4) var(--space-5);
  border-top: 1px solid var(--border-light);
  background-color: var(--surface-tertiary);
}

/* Button styles */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-2) var(--space-4);
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid transparent;
  text-decoration: none;
  position: relative;
  overflow: hidden;
  letter-spacing: -0.01em;
}

.btn:focus {
  outline: none;
  box-shadow: var(--focus-ring);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.btn-primary {
  background: var(--gradient-primary);
  color: white;
  border: 1px solid var(--primary-600);
  box-shadow: var(--shadow-sm);
}

.btn-primary:hover {
  background: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-700) 100%);
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.btn-primary:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
  background: linear-gradient(135deg, var(--primary-700) 0%, var(--primary-800) 100%);
}

.btn-primary.loading {
  cursor: not-allowed;
  color: transparent;
}

.btn-primary.loading::after {
  content: '';
  position: absolute;
  width: 1rem;
  height: 1rem;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.btn-secondary {
  background-color: var(--surface-primary);
  color: var(--gray-700);
  border: 1px solid var(--border-medium);
  box-shadow: var(--shadow-xs);
}

.btn-secondary:hover {
  background-color: var(--gray-50);
  border-color: var(--border-strong);
  box-shadow: var(--shadow-sm);
  transform: translateY(-1px);
}

.btn-secondary:active {
  transform: translateY(0);
  box-shadow: var(--shadow-xs);
  background-color: var(--gray-100);
}

.btn-sm {
  padding: var(--space-1) var(--space-3);
  font-size: 0.75rem;
}

.btn-text {
  background: none;
  border: none;
  color: var(--gray-600);
  padding: var(--space-1) var(--space-2);
  font-size: 0.875rem;
}

.btn-text:hover {
  color: var(--gray-700);
  background-color: var(--gray-100);
  transform: translateY(-1px);
}

.btn-text:active {
  color: var(--gray-800);
  background-color: var(--gray-200);
  transform: translateY(0);
}

.btn-danger {
  background: linear-gradient(135deg, var(--danger-500) 0%, var(--danger-600) 100%);
  color: white;
  border: 1px solid var(--danger-600);
  box-shadow: var(--shadow-sm);
}

.btn-danger:hover {
  background: linear-gradient(135deg, var(--danger-600) 0%, var(--danger-700) 100%);
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.btn-danger:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
  background: linear-gradient(135deg, var(--danger-700) 0%, var(--danger-800) 100%);
}

/* Form styles */
.form-group {
  margin-bottom: var(--space-4);
}

.form-label {
  display: block;
  margin-bottom: var(--space-2);
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--gray-700);
  letter-spacing: -0.01em;
}

.form-control {
  display: block;
  width: 100%;
  padding: var(--space-3) var(--space-3);
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--gray-700);
  background-color: var(--surface-primary);
  border: 1px solid var(--border-medium);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-xs);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 400;
}

.form-control::placeholder {
  color: var(--gray-400);
  opacity: 1;
}

.form-control:hover {
  border-color: var(--border-strong);
  box-shadow: 0 2px 4px rgba(16, 24, 40, 0.08);
}

.form-control:focus {
  border-color: var(--primary-500);
  outline: none;
  box-shadow: var(--focus-ring), 0 2px 4px rgba(59, 130, 246, 0.1);
  background-color: var(--surface-primary);
  transform: translateY(-1px);
}

.form-control.error {
  border-color: var(--danger-500);
  box-shadow: var(--focus-ring-error);
}

.form-control.error:focus {
  border-color: var(--danger-600);
  box-shadow: var(--focus-ring-error), 0 2px 4px rgba(239, 68, 68, 0.1);
}

.amount-input-group {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.amount-input-group .form-control {
  flex: 1 1;
}

.amount-input-group select {
  min-width: 60px;
  border-radius: var(--radius-sm);
}

/* Grid system */
.grid {
  display: grid;
  grid-gap: var(--space-6);
}

.grid-cols-1 {
  grid-template-columns: repeat(1, 1fr);
}

@media (min-width: 768px) {
  .md\\\\:grid-cols-2 {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .md\\\\:grid-cols-3 {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1024px) {
  .lg\\\\:grid-cols-3 {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .lg\\\\:grid-cols-4 {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* Utility classes */
.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.space-x-4 > * + * {
  margin-left: var(--space-4);
}

.space-y-4 > * + * {
  margin-top: var(--space-4);
}

.text-sm {
  font-size: 0.875rem;
}

.text-lg {
  font-size: 1.125rem;
}

.text-xl {
  font-size: 1.25rem;
}

.text-2xl {
  font-size: 1.5rem;
}

.font-medium {
  font-weight: 500;
}

.font-semibold {
  font-weight: 600;
}

.font-bold {
  font-weight: 700;
}

.text-primary {
  color: var(--primary-color);
}

.text-success {
  color: var(--success-color);
}

.text-danger {
  color: var(--danger-color);
}

.text-warning {
  color: var(--warning-color);
}

.text-success {
  color: var(--success-color);
}

/* Transaction Styles */
.transactions-container {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.transactions-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-4);
}

.page-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--gray-800);
  margin: 0;
}

.filter-card {
  margin-bottom: var(--space-6);
}

.filter-card.compact {
  padding-bottom: var(--space-3);
}

.filter-header {
  margin-bottom: var(--space-3);
}

.filter-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-3);
}

.filter-title-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.filter-title {
  font-size: 1.125rem;
  font-weight: 500;
  margin: 0;
}

.filter-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--gradient-primary);
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  height: 1.25rem;
  min-width: 1.25rem;
  padding: 0 var(--space-2);
  border-radius: var(--radius-full);
  margin-left: var(--space-2);
  box-shadow: var(--shadow-sm);
}

.filter-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: var(--gray-600);
  font-size: 1.25rem;
  font-weight: 600;
  width: 1.5rem;
  height: 1.5rem;
  margin-left: var(--space-2);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: var(--radius-sm);
}

.filter-toggle:hover {
  background-color: var(--gray-100);
  transform: scale(1.1);
}

.filter-toggle.expanded {
  color: var(--primary-600);
  background-color: var(--primary-50);
}

.search-container {
  margin-bottom: var(--space-3);
}

.search-input {
  width: 100%;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
}

.filter-controls {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  border-bottom: 1px solid var(--border-light);
  padding-bottom: var(--space-3);
}

.filter-section {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-4);
  width: 100%;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.filter-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--gray-600);
  margin: 0;
}

.date-range-inputs {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.date-input {
  width: 130px;
  padding: var(--space-2) var(--space-2);
  font-size: 0.875rem;
}

.date-separator {
  font-size: 0.75rem;
  color: var(--gray-500);
}

.status-select {
  width: 130px;
  padding: var(--space-2) var(--space-2);
  font-size: 0.875rem;
}

.checkbox-group {
  display: flex;
  gap: var(--space-4);
}

.checkbox-label {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.checkbox-text {
  margin-left: var(--space-2);
  font-size: 0.875rem;
  color: var(--gray-700);
}

/* Enhanced checkbox interactive states */
.table-row input[type="checkbox"] {
  width: 1rem;
  height: 1rem;
  border: 2px solid var(--border-medium);
  border-radius: var(--radius-sm);
  background-color: var(--surface-primary);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  accent-color: var(--primary-600);
}

.table-row input[type="checkbox"]:hover {
  border-color: var(--primary-400);
  background-color: var(--primary-25);
  transform: scale(1.05);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
}

.table-row input[type="checkbox"]:focus {
  outline: none;
  border-color: var(--primary-500);
  box-shadow: var(--focus-ring);
}

.table-row input[type="checkbox"]:checked {
  background-color: var(--primary-600);
  border-color: var(--primary-600);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

.table-row input[type="checkbox"]:checked:hover {
  background-color: var(--primary-700);
  border-color: var(--primary-700);
  transform: scale(1.05);
}

.table-header-cell input[type="checkbox"] {
  width: 1rem;
  height: 1rem;
  border: 2px solid var(--border-strong);
  border-radius: var(--radius-sm);
  background-color: var(--surface-primary);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  accent-color: var(--primary-600);
}

.table-header-cell input[type="checkbox"]:hover {
  border-color: var(--primary-400);
  background-color: var(--primary-25);
  transform: scale(1.05);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
}

.table-header-cell input[type="checkbox"]:focus {
  outline: none;
  border-color: var(--primary-500);
  box-shadow: var(--focus-ring);
}

.table-header-cell input[type="checkbox"]:checked {
  background-color: var(--primary-600);
  border-color: var(--primary-600);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

.table-header-cell input[type="checkbox"]:checked:hover {
  background-color: var(--primary-700);
  border-color: var(--primary-700);
  transform: scale(1.05);
}

.filter-tags-container {
  padding-bottom: var(--space-2);
}

.filter-tags-section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.filter-tags-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}

.tag-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

@media (min-width: 768px) {
  .filter-section {
    flex-wrap: nowrap;
  }
  
  .filter-tags-section {
    flex-direction: row;
  }
  
  .filter-tags-group {
    flex: 1 1;
  }
}

.category-tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.category-tag {
  display: inline-flex;
  align-items: center;
  padding: var(--space-1) var(--space-3);
  border-radius: var(--radius-full);
  font-size: 0.75rem;
  font-weight: 500;
  background-color: var(--gray-100);
  color: var(--gray-800);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid var(--gray-200);
  box-shadow: var(--shadow-xs);
}

.category-tag:hover {
  background-color: var(--gray-200);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.category-tag-active {
  background-color: var(--primary-100);
  color: var(--primary-700);
  border-color: var(--primary-300);
  box-shadow: var(--shadow-sm);
}

.category-tag-active:hover {
  background-color: var(--primary-200);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.transaction-card {
  overflow: hidden;
}

.table-responsive {
  overflow-x: auto;
  margin-bottom: var(--space-6);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  background-color: var(--surface-primary);
  border: 1px solid var(--border-light);
  max-width: 100%;
  width: 100%;
}

.data-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  white-space: nowrap;
  table-layout: fixed;
  min-width: 820px;
}

.table-header {
  background: var(--gradient-subtle);
  position: sticky;
  top: 0;
  z-index: 10;
  backdrop-filter: blur(8px);
}

.table-header-cell {
  padding: var(--space-3) var(--space-4);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--gray-600);
  text-align: left;
  border-bottom: 1px solid var(--border-light);
  height: 52px;
  background: var(--gradient-subtle);
}

.table-body {
  background-color: var(--surface-primary);
}

/* Enhanced table row interactive states */
.table-row {
  border-bottom: 1px solid var(--border-light);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  background-color: var(--surface-primary);
}

.table-row:hover {
  background-color: var(--gray-50);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.08), 0 1px 3px rgba(16, 24, 40, 0.12);
  border-color: var(--gray-300);
}

.table-row.editing-row {
  background-color: var(--primary-50);
  box-shadow: inset 0 0 0 2px var(--primary-300), 0 4px 12px rgba(59, 130, 246, 0.15);
  transform: translateY(-2px);
  border-color: var(--primary-300);
  z-index: 5;
}

.table-row.selected {
  background-color: var(--primary-25);
  box-shadow: inset 3px 0 0 var(--primary-500);
  border-color: var(--primary-200);
}

.table-row.selected:hover {
  background-color: var(--primary-50);
  transform: translateY(-1px);
  box-shadow: inset 3px 0 0 var(--primary-500), 0 2px 8px rgba(59, 130, 246, 0.12);
}

.table-cell {
  padding: var(--space-3) var(--space-4);
  vertical-align: middle;
  color: var(--gray-700);
  font-size: 0.875rem;
  height: 60px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table-row.editing-row .table-cell {
  padding: var(--space-2) var(--space-3);
}

.category-color-dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  margin-right: var(--space-2);
}

/* Category styling */
.category-display {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.category-color-dot {
  display: inline-block;
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  flex-shrink: 0;
}

/* Enhanced badge interactive states */
.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  border-radius: var(--radius-full);
  white-space: nowrap;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 0.01em;
  border: 1px solid transparent;
  cursor: default;
}

.badge.cursor-pointer {
  cursor: pointer;
}

.badge.cursor-pointer:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(16, 24, 40, 0.12);
}

.badge.cursor-pointer:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);
}

.badge-primary.cursor-pointer:hover {
  background-color: var(--primary-200);
  border-color: var(--primary-400);
  color: var(--primary-800);
}

.badge-success.cursor-pointer:hover {
  background-color: var(--success-200);
  border-color: var(--success-400);
  color: var(--success-800);
}

.badge-warning.cursor-pointer:hover {
  background-color: var(--warning-200);
  border-color: var(--warning-400);
  color: var(--warning-800);
}

.badge-danger.cursor-pointer:hover {
  background-color: var(--danger-200);
  border-color: var(--danger-400);
  color: var(--danger-800);
}

.badge-secondary.cursor-pointer:hover {
  background-color: var(--gray-200);
  border-color: var(--gray-400);
  color: var(--gray-800);
}

.badge-info.cursor-pointer:hover {
  background-color: var(--primary-200);
  border-color: var(--primary-400);
  color: var(--primary-800);
}

/* Badge sizes */
.badge-sm {
  padding: var(--space-1) var(--space-2);
  font-size: 0.75rem;
  line-height: 1.2;
}

.badge-md {
  padding: var(--space-1) var(--space-3);
  font-size: 0.8125rem;
  line-height: 1.3;
}

.badge-lg {
  padding: var(--space-2) var(--space-4);
  font-size: 0.875rem;
  line-height: 1.4;
}

/* Badge variants */
.badge-primary {
  background-color: var(--primary-100);
  color: var(--primary-700);
  border-color: var(--primary-200);
}

.badge-success {
  background-color: var(--success-100);
  color: var(--success-700);
  border-color: var(--success-200);
}

.badge-warning {
  background-color: var(--warning-100);
  color: var(--warning-700);
  border-color: var(--warning-200);
}

.badge-danger {
  background-color: var(--danger-100);
  color: var(--danger-700);
  border-color: var(--danger-200);
}

.badge-secondary {
  background-color: var(--gray-100);
  color: var(--gray-700);
  border-color: var(--gray-200);
}

.badge-info {
  background-color: var(--primary-100);
  color: var(--primary-600);
  border-color: var(--primary-200);
}

/* Form control sizing */
.form-control-sm {
  padding: var(--space-1) var(--space-2);
  font-size: 0.75rem;
}

/* Enhanced editable cell interactive states */
.editable-cell {
  cursor: pointer;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: var(--radius-sm);
  margin: 2px;
}

.editable-cell:hover {
  background-color: var(--gray-100);
  transform: translateX(2px);
  box-shadow: inset 3px 0 0 var(--primary-300), 0 2px 4px rgba(16, 24, 40, 0.08);
  border-radius: var(--radius-sm);
}

.editable-cell.editing {
  background-color: var(--primary-50);
  box-shadow: inset 0 0 0 2px var(--primary-400), 0 4px 12px rgba(59, 130, 246, 0.15);
  transform: translateX(4px);
  border-radius: var(--radius-md);
  z-index: 10;
}

.editable-cell.editing .form-control {
  border: none;
  box-shadow: none;
  background-color: transparent;
  color: var(--gray-800);
  font-weight: 500;
}

.editable-cell.editing .form-control:focus {
  box-shadow: none;
  border-color: transparent;
}

.editable-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 1.5rem;
}

.editable-content .group {
  display: flex;
  align-items: center;
  width: 100%;
}

/* Actions cell styling */
.actions-cell {
  width: 80px;
  min-width: 80px;
  white-space: nowrap;
  text-align: center;
}

/* Status column specific styling */
.status-cell {
  width: 120px;
  min-width: 120px;
  white-space: nowrap;
}

/* Amount cell styling */
.amount-cell {
  font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
  font-weight: 500;
  text-align: right;
}

/* GL account search wrapper */
.gl-account-search-wrapper {
  position: relative;
  z-index: 20;
}

.table-gl-search {
  font-size: 0.875rem;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
}

/* Enhanced modal styling */
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-6);
  border-bottom: 1px solid var(--border-light);
}

.modal-body {
  padding: var(--space-6);
  max-height: 70vh;
  overflow-y: auto;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: var(--space-6);
  border-top: 1px solid var(--border-light);
  background: var(--gray-25);
}

/* Transition utilities */
.transition-colors {
  transition: color 0.2s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.transition-opacity {
  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Opacity utilities */
.opacity-0 {
  opacity: 0;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

/* Utility classes for common patterns */
.inline-flex {
  display: inline-flex;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Enhanced animation keyframes */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes backdropFadeIn {
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(4px);
  }
}

@keyframes slideUp {
  from {
    transform: translateY(100px);
    opacity: 0;
    scale: 0.95;
  }
  to {
    transform: translateY(0);
    opacity: 1;
    scale: 1;
  }
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes expandIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

@keyframes dots {
  0%, 20% {
    color: rgba(0, 0, 0, 0);
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  40% {
    color: var(--gray-600);
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  60% {
    text-shadow: 0.25em 0 0 var(--gray-600), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  80%, 100% {
    text-shadow: 0.25em 0 0 var(--gray-600), 0.5em 0 0 var(--gray-600);
  }
}

@keyframes fadeInOut {
  0%, 20% {
    opacity: 0;
  }
  40%, 60% {
    opacity: 0.8;
  }
  80%, 100% {
    opacity: 0;
  }
}

/* Enhanced loading state animations */
.loading-spinner {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid var(--gray-200);
  border-radius: 50%;
  border-top-color: var(--primary-600);
  animation: spin 1s linear infinite;
}

.loading-spinner-sm {
  width: 0.75rem;
  height: 0.75rem;
  border-width: 1.5px;
}

.loading-spinner-lg {
  width: 1.5rem;
  height: 1.5rem;
  border-width: 3px;
}

.loading-dots {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
}

.loading-dots::after {
  content: '';
  animation: dots 1.5s linear infinite;
}

.pulse-loading {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Enhanced selection state visual feedback */
.selection-indicator {
  position: relative;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.selection-indicator::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0;
  background: var(--gradient-primary);
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
}

.selection-indicator.selected::before {
  width: 3px;
}

.bulk-actions {
  background: var(--gradient-primary);
  color: white;
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-lg);
  margin-bottom: var(--space-4);
  box-shadow: var(--shadow-lg);
  animation: slideDown 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.bulk-actions .btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
}

.bulk-actions .btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Enhanced focus styles for accessibility */
input:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: var(--primary-500);
  box-shadow: var(--focus-ring);
  transform: translateY(-1px);
}

input:focus-visible,
select:focus-visible,
textarea:focus-visible {
  outline: 2px solid var(--primary-500);
  outline-offset: 2px;
}

button:focus-visible {
  outline: 2px solid var(--primary-500);
  outline-offset: 2px;
}

/* Custom focus styles for table interactions */
.table-row:focus-within {
  background-color: var(--primary-25);
  box-shadow: inset 0 0 0 2px var(--primary-200);
}

.editable-cell:focus-within {
  background-color: var(--primary-50);
  box-shadow: inset 0 0 0 2px var(--primary-300);
  border-radius: var(--radius-sm);
}

/* Enhanced accessibility helpers */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.focus-trap {
  position: fixed;
  inset: 0;
  z-index: 9999;
}

.focus-visible {
  outline: 2px solid var(--primary-500);
  outline-offset: 2px;
}

.skip-link {
  position: absolute;
  top: -40px;
  left: 6px;
  background: var(--primary-600);
  color: white;
  padding: 8px;
  text-decoration: none;
  border-radius: var(--radius-sm);
  z-index: 100;
  transition: top 0.2s;
}

.skip-link:focus {
  top: 6px;
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .table-row:hover {
    background-color: var(--gray-200);
    border: 2px solid var(--gray-600);
  }
  
  .btn:focus {
    outline: 3px solid var(--primary-600);
    outline-offset: 2px;
  }
  
  .form-control:focus {
    outline: 2px solid var(--primary-600);
    outline-offset: 1px;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* Table specific hover effects */
.table-row:hover .editable-cell {
  background-color: var(--gray-50);
}

.table-row:hover .group .group-hover\\:opacity-100 {
  opacity: 1;
}

/* Empty state styling */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-12) var(--space-4);
  text-align: center;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  padding: var(--space-1);
  border-radius: var(--radius-sm);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.btn-icon:hover {
  background-color: var(--gray-100);
  transform: scale(1.1);
  box-shadow: 0 2px 4px rgba(16, 24, 40, 0.1);
}

.btn-icon:active {
  transform: scale(0.95);
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.1);
}

.btn-icon:focus {
  outline: none;
  box-shadow: var(--focus-ring);
}

.btn-edit {
  color: var(--primary-600);
}

.btn-edit:hover {
  color: var(--primary-700);
  background-color: var(--primary-50);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.15);
}

.btn-edit:active {
  color: var(--primary-800);
  background-color: var(--primary-100);
}

.btn-delete {
  color: var(--danger-600);
}

.btn-delete:hover {
  color: var(--danger-700);
  background-color: var(--danger-50);
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.15);
}

.btn-delete:active {
  color: var(--danger-800);
  background-color: var(--danger-100);
}

.btn-link {
  background: none;
  border: none;
  padding: 0;
  font-size: 0.875rem;
  color: var(--primary-600);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-link:hover {
  color: var(--primary-700);
  text-decoration-color: var(--primary-700);
}

.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 50;
  overflow-y: auto;
  animation: fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-container {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  min-height: 100vh;
  padding: var(--space-4);
  text-align: center;
}

@media (min-width: 640px) {
  .modal-container {
    display: block;
    padding: 0;
  }
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(16, 24, 40, 0.7);
  backdrop-filter: blur(4px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: backdropFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-helper {
  display: none;
}

@media (min-width: 640px) {
  .modal-helper {
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
  }
}

.modal-content {
  display: inline-block;
  vertical-align: bottom;
  background-color: var(--surface-primary);
  border-radius: var(--radius-xl);
  text-align: left;
  overflow: hidden;
  box-shadow: var(--shadow-2xl);
  transform: translateY(0);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid var(--border-light);
  animation: slideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-content:hover {
  box-shadow: var(--shadow-2xl), 0 0 0 1px rgba(59, 130, 246, 0.1);
}

@media (min-width: 640px) {
  .modal-content {
    vertical-align: middle;
    margin: var(--space-8) auto;
    max-width: 32rem;
    width: 100%;
  }
}

.text-gray-400 {
  color: var(--gray-400);
}

/* Loading container for code splitting */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  font-size: 1.25rem;
  color: var(--primary-600);
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  backdrop-filter: blur(8px);
}

.text-gray-500 {
  color: var(--gray-500);
}

.text-gray-600 {
  color: var(--gray-600);
}

.text-gray-700 {
  color: var(--gray-700);
}

.text-gray-800 {
  color: var(--gray-800);
}

.bg-white {
  background-color: white;
}

.bg-primary {
  background-color: var(--primary-color);
}

.bg-success {
  background-color: var(--success-color);
}

.bg-danger {
  background-color: var(--danger-color);
}

.bg-warning {
  background-color: var(--warning-color);
}

.rounded {
  border-radius: var(--radius-sm);
}

.rounded-full {
  border-radius: var(--radius-full);
}

.shadow-sm {
  box-shadow: var(--shadow-sm);
}

.p-1 {
  padding: var(--space-1);
}

.p-2 {
  padding: var(--space-2);
}

.p-4 {
  padding: var(--space-4);
}

.px-4 {
  padding-left: var(--space-4);
  padding-right: var(--space-4);
}

.py-2 {
  padding-top: var(--space-2);
  padding-bottom: var(--space-2);
}

.py-4 {
  padding-top: var(--space-4);
  padding-bottom: var(--space-4);
}

.m-2 {
  margin: var(--space-2);
}

.m-4 {
  margin: var(--space-4);
}

.mb-2 {
  margin-bottom: var(--space-2);
}

.mb-4 {
  margin-bottom: var(--space-4);
}

.mt-2 {
  margin-top: var(--space-2);
}

.mt-4 {
  margin-top: var(--space-4);
}

.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}

.hidden {
  display: none;
}

@media (min-width: 768px) {
  .md\\\\:block {
    display: block;
  }
  
  .md\\\\:flex {
    display: flex;
  }
  
  .md\\\\:hidden {
    display: none;
  }
}

/* Enhanced micro-interactions and polish */
.edit-actions {
  animation: fadeInUp 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.table-cell .editable-content {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.table-cell .editable-content:hover {
  padding-left: var(--space-2);
}

.gl-account-search-wrapper {
  animation: expandIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.category-display {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.category-display:hover {
  transform: translateX(2px);
}

.category-color-dot {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.category-display:hover .category-color-dot {
  transform: scale(1.2);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.transaction-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.transaction-card:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-lg);
}

.error-message {
  color: var(--danger-600);
  font-size: 0.75rem;
  margin-top: var(--space-1);
  animation: slideIn 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.success-message {
  color: var(--success-600);
  font-size: 0.75rem;
  margin-top: var(--space-1);
  animation: slideIn 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.ripple {
  position: relative;
  overflow: hidden;
}

.ripple::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  transition: width 0.6s, height 0.6s;
  transform: translate(-50%, -50%);
}

.ripple:active::before {
  width: 300px;
  height: 300px;
}

/* Enhanced table specific hover effects */
.table-row:hover .group .group-hover\\\\:opacity-100 {
  opacity: 1;
  transform: translateX(2px);
}

.table-row:hover .btn-icon {
  transform: translateX(2px);
}

.table-row:hover .category-color-dot {
  transform: scale(1.1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.table-row:hover .badge {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Row selection enhancement */
.table-row.selected {
  background: linear-gradient(90deg, var(--primary-25) 0%, var(--surface-primary) 100%);
  border-left: 3px solid var(--primary-500);
}

.table-row.selected:hover {
  background: linear-gradient(90deg, var(--primary-50) 0%, var(--gray-50) 100%);
}

/* ========================== */
/* MOBILE RESPONSIVENESS ENHANCEMENTS */
/* ========================== */

/* Mobile-first breakpoints */
/* Small mobile: 320px - 479px */
/* Large mobile: 480px - 767px */
/* Tablet: 768px - 1023px */
/* Desktop: 1024px+ */

/* Mobile Base Styles */
@media (max-width: 767px) {
  /* Enhanced mobile container */
  .page-content {
    padding: var(--space-3) var(--space-2);
  }
  
  /* Mobile card styling */
  .card {
    margin-bottom: var(--space-4);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
  }
  
  .card-body {
    padding: var(--space-3);
  }
  
  /* Mobile transaction card */
  .transaction-card {
    padding: 0;
    margin-bottom: var(--space-3);
  }
  
  /* Mobile table responsive wrapper */
  .table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: var(--gray-300) transparent;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    position: relative;
  }
  
  /* Show scroll hint on mobile */
  .table-responsive::after {
    content: '← Swipe to see all columns →';
    position: absolute;
    bottom: 4px;
    right: 8px;
    background: rgba(59, 130, 246, 0.9);
    color: white;
    padding: 2px 8px;
    border-radius: var(--radius-sm);
    font-size: 0.625rem;
    font-weight: 500;
    pointer-events: none;
    z-index: 10;
    opacity: 0.8;
    animation: fadeInOut 6s ease-in-out;
    animation-fill-mode: forwards;
  }
  
  /* Hide hint when scrolling */
  .table-responsive.scrolling::after {
    display: none;
  }
  
  .table-responsive::-webkit-scrollbar {
    height: 6px;
  }
  
  .table-responsive::-webkit-scrollbar-track {
    background: var(--gray-100);
    border-radius: var(--radius-sm);
  }
  
  .table-responsive::-webkit-scrollbar-thumb {
    background: var(--gray-300);
    border-radius: var(--radius-sm);
  }
  
  .table-responsive::-webkit-scrollbar-thumb:hover {
    background: var(--gray-400);
  }
  
  /* Mobile data table */
  .data-table {
    min-width: 820px; /* Ensure table doesn't collapse */
    font-size: 0.8125rem; /* Slightly smaller for mobile */
    table-layout: fixed;
  }
  
  /* Mobile table header */
  .table-header {
    position: sticky;
    top: 0;
    z-index: 15;
    background: var(--gradient-subtle);
    backdrop-filter: blur(10px);
    border-bottom: 2px solid var(--border-medium);
  }
  
  .table-header-cell {
    padding: var(--space-2) var(--space-3);
    font-size: 0.6875rem;
    font-weight: 600;
    height: 44px;
    vertical-align: middle;
    white-space: nowrap;
  }
  
  /* Mobile table body */
  .table-body {
    position: relative;
  }
  
  /* Mobile table rows - Touch-friendly */
  .table-row {
    min-height: 52px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    border-bottom: 1px solid var(--border-light);
  }
  
  .table-row:hover {
    background-color: var(--gray-50);
    box-shadow: 0 1px 4px rgba(16, 24, 40, 0.06);
    transform: none; /* Remove desktop hover transform on mobile */
  }
  
  .table-row.selected {
    background: linear-gradient(90deg, var(--primary-25) 0%, var(--surface-primary) 100%);
    border-left: 4px solid var(--primary-500);
  }
  
  .table-row.selected:hover {
    background: linear-gradient(90deg, var(--primary-50) 0%, var(--gray-50) 100%);
  }
  
  /* Mobile table cells - Touch-friendly */
  .table-cell {
    padding: var(--space-2) var(--space-3);
    font-size: 0.8125rem;
    line-height: 1.4;
    height: 52px;
    vertical-align: middle;
    white-space: nowrap;
  }
  
  /* Mobile-specific cell adjustments */
  .table-cell input,
  .table-cell select {
    padding: var(--space-2);
    font-size: 0.8125rem;
    min-height: 36px; /* Touch-friendly minimum */
  }
  
  /* Mobile checkbox styling - Touch-friendly */
  .table-row input[type="checkbox"],
  .table-header-cell input[type="checkbox"] {
    width: 1.125rem;
    height: 1.125rem;
    min-width: 1.125rem;
    min-height: 1.125rem;
    border: 2px solid var(--border-medium);
    border-radius: var(--radius-sm);
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .table-row input[type="checkbox"]:hover,
  .table-header-cell input[type="checkbox"]:hover {
    border-color: var(--primary-400);
    background-color: var(--primary-25);
    transform: scale(1.1);
  }
  
  .table-row input[type="checkbox"]:checked,
  .table-header-cell input[type="checkbox"]:checked {
    background-color: var(--primary-600);
    border-color: var(--primary-600);
  }
  
  /* Mobile editable cells - Touch-friendly */
  .editable-cell {
    cursor: pointer;
    border-radius: var(--radius-sm);
    margin: 1px;
    min-height: 44px; /* Touch-friendly minimum */
    display: flex;
    align-items: center;
  }
  
  .editable-cell:hover {
    background-color: var(--gray-100);
    transform: none; /* Remove desktop transform */
    box-shadow: inset 2px 0 0 var(--primary-300);
  }
  
  .editable-cell.editing {
    background-color: var(--primary-50);
    box-shadow: inset 0 0 0 2px var(--primary-400);
    border-radius: var(--radius-md);
    z-index: 20;
  }
  
  .editable-content {
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: var(--space-1);
  }
  
  /* Mobile button styles - Touch-friendly */
  .btn {
    min-height: 44px;
    padding: var(--space-2) var(--space-4);
    font-size: 0.875rem;
    border-radius: var(--radius-md);
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .btn:hover {
    transform: translateY(-1px);
    box-shadow: var(--shadow-md);
  }
  
  .btn:active {
    transform: translateY(0);
    box-shadow: var(--shadow-sm);
  }
  
  .btn-sm {
    min-height: 36px;
    padding: var(--space-1) var(--space-3);
    font-size: 0.75rem;
  }
  
  /* Mobile icon buttons - Touch-friendly */
  .btn-icon {
    min-width: 44px;
    min-height: 44px;
    padding: var(--space-2);
    border-radius: var(--radius-md);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .btn-icon:hover {
    background-color: var(--gray-100);
    transform: scale(1.05);
    box-shadow: 0 2px 4px rgba(16, 24, 40, 0.1);
  }
  
  .btn-icon:active {
    transform: scale(0.98);
  }
  
  .btn-edit:hover {
    background-color: var(--primary-50);
    color: var(--primary-700);
  }
  
  .btn-delete:hover {
    background-color: var(--danger-50);
    color: var(--danger-700);
  }
  
  /* Mobile badges - Touch-friendly */
  .badge {
    min-height: 24px;
    padding: var(--space-1) var(--space-2);
    font-size: 0.6875rem;
    font-weight: 500;
    border-radius: var(--radius-full);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }
  
  .badge.cursor-pointer {
    min-height: 32px;
    padding: var(--space-1) var(--space-3);
    cursor: pointer;
  }
  
  .badge.cursor-pointer:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(16, 24, 40, 0.12);
  }
  
  .badge.cursor-pointer:active {
    transform: translateY(0);
  }
  
  /* Mobile form controls - Touch-friendly */
  .form-control {
    min-height: 44px;
    padding: var(--space-3);
    font-size: 0.875rem;
    border-radius: var(--radius-md);
    border: 2px solid var(--border-medium);
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .form-control:focus {
    border-color: var(--primary-500);
    box-shadow: var(--focus-ring);
    transform: translateY(-1px);
  }
  
  .form-control::placeholder {
    color: var(--gray-400);
    font-size: 0.875rem;
  }
  
  /* Mobile GL Account search */
  .gl-account-search-wrapper {
    position: relative;
    z-index: 25;
  }
  
  .table-gl-search {
    min-height: 44px;
    font-size: 0.875rem;
    border-radius: var(--radius-md);
    border: 2px solid var(--primary-400);
    box-shadow: var(--shadow-sm);
  }
  
  .table-gl-search:focus {
    border-color: var(--primary-500);
    box-shadow: var(--focus-ring);
  }

  /* Modal responsiveness */
  .modal-content {
    margin: var(--space-4);
    max-height: calc(100vh - 2rem);
  }

  .modal-body {
    max-height: calc(70vh - 200px);
    padding: var(--space-4);
  }

  .modal-header,
  .modal-footer {
    padding: var(--space-4);
  }
  
  .edit-actions {
    margin-top: var(--space-3);
    display: flex;
    gap: var(--space-2);
    justify-content: flex-end;
  }
  
  .edit-actions .btn-sm {
    min-height: 36px;
    padding: var(--space-2) var(--space-3);
  }
  
  /* Mobile amount input group */
  .amount-input-group {
    display: flex;
    align-items: center;
    gap: var(--space-2);
  }
  
  .amount-input-group select {
    min-height: 44px;
    min-width: 70px;
    padding: var(--space-2);
    border-radius: var(--radius-md);
  }
  
  .amount-input-group input {
    min-height: 44px;
    flex: 1 1;
    padding: var(--space-2) var(--space-3);
    border-radius: var(--radius-md);
  }
  
  /* Mobile category display */
  .category-display {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    min-height: 44px;
  }
  
  .category-color-dot {
    width: 0.875rem;
    height: 0.875rem;
    border-radius: 50%;
    flex-shrink: 0;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .category-display:hover .category-color-dot {
    transform: scale(1.15);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  /* Mobile actions cell */
  .actions-cell {
    width: 100px;
    text-align: center;
  }
  
  .actions-cell .flex {
    justify-content: center;
    align-items: center;
    gap: var(--space-2);
  }
  
  /* Mobile bulk actions */
  .bulk-actions {
    margin-bottom: var(--space-3);
    padding: var(--space-3);
    border-radius: var(--radius-md);
    background: var(--gradient-primary);
    color: white;
    box-shadow: var(--shadow-md);
  }
  
  .bulk-actions .btn {
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(10px);
    min-height: 44px;
  }
  
  .bulk-actions .btn:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-1px);
  }
  
  /* Mobile modal optimizations */
  .modal-container {
    padding: var(--space-3);
    align-items: flex-end;
  }
  
  .modal-content {
    border-radius: var(--radius-xl) var(--radius-xl) 0 0;
    max-height: 80vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  .modal-content > div {
    padding: var(--space-4);
  }
  
  /* Mobile search and filter optimization */
  .search-input {
    min-height: 44px;
    padding: var(--space-3);
    font-size: 0.875rem;
    border-radius: var(--radius-md);
  }
  
  .filter-controls {
    gap: var(--space-3);
  }
  
  .filter-group {
    gap: var(--space-2);
  }
  
  .date-input,
  .status-select {
    min-height: 44px;
    padding: var(--space-2);
    font-size: 0.875rem;
    border-radius: var(--radius-md);
  }
  
  /* Mobile category tags */
  .category-tag {
    min-height: 36px;
    padding: var(--space-2) var(--space-3);
    font-size: 0.75rem;
    border-radius: var(--radius-full);
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .category-tag:hover {
    transform: translateY(-1px);
    box-shadow: var(--shadow-sm);
  }
  
  .category-tag:active {
    transform: translateY(0);
  }
  
  /* Mobile loading states */
  .loading-spinner {
    width: 1.25rem;
    height: 1.25rem;
    border-width: 2px;
  }
  
  .loading-spinner-sm {
    width: 1rem;
    height: 1rem;
    border-width: 2px;
  }
  
  .loading-spinner-lg {
    width: 1.75rem;
    height: 1.75rem;
    border-width: 3px;
  }
  
  /* Mobile hover state optimizations */
  .table-row:hover .group .group-hover\\\\:opacity-100 {
    opacity: 1;
  }
  
  .table-row:hover .btn-icon {
    transform: none; /* Remove desktop transform */
  }
  
  /* Mobile focus states */
  .table-row:focus-within {
    background-color: var(--primary-25);
    box-shadow: inset 0 0 0 2px var(--primary-200);
  }
  
  .editable-cell:focus-within {
    background-color: var(--primary-50);
    box-shadow: inset 0 0 0 2px var(--primary-300);
  }
  
  /* Mobile typography adjustments */
  .page-title {
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: var(--space-3);
  }
  
  .filter-title {
    font-size: 1rem;
    font-weight: 600;
  }
  
  .filter-badge {
    height: 1.125rem;
    min-width: 1.125rem;
    font-size: 0.6875rem;
    font-weight: 600;
  }
  
  /* Mobile error and success states */
  .error-message,
  .success-message {
    font-size: 0.75rem;
    margin-top: var(--space-1);
    padding: var(--space-1);
    border-radius: var(--radius-sm);
  }
  
  .error-message {
    background-color: var(--danger-50);
    color: var(--danger-700);
    border: 1px solid var(--danger-200);
  }
  
  .success-message {
    background-color: var(--success-50);
    color: var(--success-700);
    border: 1px solid var(--success-200);
  }
}

/* Large Mobile Styles (480px - 767px) */
@media (min-width: 480px) and (max-width: 767px) {
  .page-content {
    padding: var(--space-4) var(--space-3);
  }
  
  .card-body {
    padding: var(--space-4);
  }
  
  .table-header-cell {
    padding: var(--space-3) var(--space-4);
    font-size: 0.75rem;
    height: 48px;
  }
  
  .table-cell {
    padding: var(--space-3) var(--space-4);
    font-size: 0.875rem;
    height: 56px;
  }
  
  .data-table {
    min-width: 820px;
    font-size: 0.875rem;
    table-layout: fixed;
  }
  
  .btn-icon {
    min-width: 40px;
    min-height: 40px;
    padding: var(--space-2);
  }
  
  .form-control {
    min-height: 48px;
    padding: var(--space-3) var(--space-4);
  }
  
  .badge {
    min-height: 28px;
    padding: var(--space-1) var(--space-3);
    font-size: 0.75rem;
  }
  
  .page-title {
    font-size: 1.375rem;
  }
}

/* Tablet Styles (768px - 1023px) */
@media (min-width: 768px) and (max-width: 1023px) {
  .page-content {
    padding: var(--space-5) var(--space-4);
  }
  
  .table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  .data-table {
    min-width: 1100px;
  }
  
  .table-header-cell {
    height: 50px;
    padding: var(--space-3) var(--space-4);
    font-size: 0.75rem;
  }
  
  .table-cell {
    height: 58px;
    padding: var(--space-3) var(--space-4);
    font-size: 0.875rem;
  }
  
  .btn-icon {
    min-width: 36px;
    min-height: 36px;
  }
  
  .form-control {
    min-height: 44px;
  }
  
  .modal-container {
    padding: var(--space-4);
    align-items: center;
  }
  
  .modal-content {
    border-radius: var(--radius-xl);
    max-height: 90vh;
  }
}

/* Desktop Styles (1024px+) - Maintain existing desktop experience */
@media (min-width: 1024px) {
  .table-responsive {
    overflow-x: auto; /* Allow scrolling if needed even on desktop */
  }
  
  .table-responsive::after {
    display: none;
  }
  
  .data-table {
    min-width: 820px;
    table-layout: fixed;
  }
  
  /* Restore original desktop hover effects */
  .table-row:hover {
    background-color: var(--gray-50);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.08), 0 1px 3px rgba(16, 24, 40, 0.12);
  }
  
  .editable-cell:hover {
    background-color: var(--gray-100);
    transform: translateX(2px);
    box-shadow: inset 3px 0 0 var(--primary-300), 0 2px 4px rgba(16, 24, 40, 0.08);
  }
  
  .table-row:hover .group .group-hover\\\\:opacity-100 {
    opacity: 1;
    transform: translateX(2px);
  }
  
  .table-row:hover .btn-icon {
    transform: translateX(2px);
  }
}

/* Touch device optimizations */
@media (hover: none) and (pointer: coarse) {
  /* Remove hover effects on touch devices */
  .table-row:hover {
    background-color: var(--surface-primary);
    transform: none;
    box-shadow: none;
  }
  
  .editable-cell:hover {
    background-color: var(--surface-primary);
    transform: none;
    box-shadow: none;
  }
  
  .btn:hover {
    transform: none;
    box-shadow: var(--shadow-sm);
  }
  
  .btn-icon:hover {
    transform: none;
    background-color: var(--surface-primary);
  }
  
  .badge:hover {
    transform: none;
  }
  
  .category-tag:hover {
    transform: none;
  }
  
  /* Enhanced touch feedback */
  .table-row:active {
    background-color: var(--gray-100);
    transform: scale(0.99);
  }
  
  .editable-cell:active {
    background-color: var(--primary-100);
    transform: scale(0.98);
  }
  
  .btn:active {
    transform: scale(0.96);
  }
  
  .btn-icon:active {
    transform: scale(0.92);
    background-color: var(--gray-100);
  }
  
  .badge:active {
    transform: scale(0.95);
  }
}

/* High DPI screen optimizations */
@media (min-resolution: 192dpi) {
  .table-responsive::-webkit-scrollbar {
    height: 8px;
  }
  
  .table-row input[type="checkbox"],
  .table-header-cell input[type="checkbox"] {
    border-width: 1px;
  }
  
  .loading-spinner {
    border-width: 1px;
  }
  
  .loading-spinner-sm {
    border-width: 1px;
  }
  
  .loading-spinner-lg {
    border-width: 2px;
  }
}

/* Landscape phone optimizations */
@media (max-width: 767px) and (orientation: landscape) {
  .page-content {
    padding: var(--space-2) var(--space-3);
  }
  
  .table-header-cell {
    height: 40px;
    padding: var(--space-2) var(--space-3);
    font-size: 0.6875rem;
  }
  
  .table-cell {
    height: 48px;
    padding: var(--space-2) var(--space-3);
    font-size: 0.8125rem;
  }
  
  .btn {
    min-height: 36px;
    padding: var(--space-2) var(--space-3);
  }
  
  .btn-icon {
    min-width: 36px;
    min-height: 36px;
    padding: var(--space-1);
  }
  
  .form-control {
    min-height: 36px;
    padding: var(--space-2) var(--space-3);
  }
  
  .modal-content {
    max-height: 70vh;
  }
}

/* Small screen optimizations for very small devices */
@media (max-width: 320px) {
  .page-content {
    padding: var(--space-2) var(--space-1);
  }
  
  .data-table {
    min-width: 800px;
    font-size: 0.75rem;
  }
  
  .table-header-cell {
    padding: var(--space-1) var(--space-2);
    font-size: 0.625rem;
    height: 40px;
  }
  
  .table-cell {
    padding: var(--space-1) var(--space-2);
    font-size: 0.75rem;
    height: 48px;
  }
  
  .btn {
    min-height: 40px;
    padding: var(--space-2) var(--space-3);
    font-size: 0.8125rem;
  }
  
  .btn-sm {
    min-height: 32px;
    padding: var(--space-1) var(--space-2);
    font-size: 0.6875rem;
  }
  
  .btn-icon {
    min-width: 40px;
    min-height: 40px;
    padding: var(--space-1);
  }
  
  .form-control {
    min-height: 40px;
    padding: var(--space-2);
    font-size: 0.8125rem;
  }
  
  .badge {
    min-height: 20px;
    padding: var(--space-1) var(--space-2);
    font-size: 0.625rem;
  }
  
  .page-title {
    font-size: 1.125rem;
  }
}

/* Dark mode mobile optimizations */
@media (prefers-color-scheme: dark) {
  @media (max-width: 767px) {
    .table-responsive::-webkit-scrollbar-track {
      background: var(--gray-800);
    }
    
    .table-responsive::-webkit-scrollbar-thumb {
      background: var(--gray-600);
    }
    
    .table-responsive::-webkit-scrollbar-thumb:hover {
      background: var(--gray-500);
    }
    
    .table-row:hover {
      background-color: var(--gray-800);
    }
    
    .editable-cell:hover {
      background-color: var(--gray-700);
    }
    
    .btn-icon:hover {
      background-color: var(--gray-800);
    }
    
    .form-control {
      background-color: var(--gray-900);
      border-color: var(--gray-700);
      color: var(--gray-100);
    }
    
    .form-control:focus {
      border-color: var(--primary-400);
      background-color: var(--gray-800);
    }
    
    .modal-content {
      background-color: var(--gray-900);
      border-color: var(--gray-700);
    }
    
    .error-message {
      background-color: var(--danger-900);
      color: var(--danger-300);
      border-color: var(--danger-700);
    }
    
    .success-message {
      background-color: var(--success-900);
      color: var(--success-300);
      border-color: var(--success-700);
    }
  }
}

/* Accessibility improvements for mobile */
@media (max-width: 767px) {
  /* Focus indicators */
  .table-row:focus-within {
    outline: 2px solid var(--primary-500);
    outline-offset: 2px;
  }
  
  .editable-cell:focus-within {
    outline: 2px solid var(--primary-500);
    outline-offset: 1px;
  }
  
  .btn:focus-visible {
    outline: 2px solid var(--primary-500);
    outline-offset: 2px;
  }
  
  .form-control:focus-visible {
    outline: 2px solid var(--primary-500);
    outline-offset: 1px;
  }
  
  /* Enhanced contrast for better visibility */
  .table-row.selected {
    border-left: 4px solid var(--primary-600);
  }
  
  .badge {
    border: 1px solid transparent;
  }
  
  .badge-primary {
    border-color: var(--primary-300);
  }
  
  .badge-success {
    border-color: var(--success-300);
  }
  
  .badge-warning {
    border-color: var(--warning-300);
  }
  
  .badge-danger {
    border-color: var(--danger-300);
  }
}

/* Animation performance optimizations for mobile */
@media (max-width: 767px) {
  .table-row,
  .editable-cell,
  .btn,
  .btn-icon,
  .badge,
  .form-control {
    transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  }
  
  /* Reduce animations on low-end devices */
  @media (max-width: 479px) {
    .table-row:hover {
      transition: none;
    }
    
    .editable-cell:hover {
      transition: none;
    }
    
    .btn:hover {
      transition: none;
    }
  }
}

/* Swipe gesture indicators */
@media (max-width: 767px) {
  .table-responsive {
    position: relative;
  }
  
  .table-responsive::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 20px;
    background: linear-gradient(to left, rgba(255, 255, 255, 0.8), transparent);
    pointer-events: none;
    z-index: 5;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  .table-responsive:hover::before {
    opacity: 1;
  }
  
  .table-responsive::after {
    content: '→';
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    color: var(--gray-400);
    font-size: 0.875rem;
    font-weight: 600;
    pointer-events: none;
    z-index: 6;
    opacity: 0;
    animation: fadeIn 0.3s ease 2s forwards;
  }
  
  .table-responsive:hover::after {
    opacity: 0;
  }
}

/* Print optimizations */
@media print {
  .table-responsive {
    overflow: visible;
  }
  
  .data-table {
    min-width: auto;
    font-size: 0.75rem;
  }
  
  .table-header-cell,
  .table-cell {
    padding: var(--space-1) var(--space-2);
  }
  
  .btn-icon,
  .btn,
  .edit-actions {
    display: none !important;
  }
  
  .table-row:hover {
    background-color: transparent;
    transform: none;
    box-shadow: none;
  }
  
  .editable-cell:hover {
    background-color: transparent;
    transform: none;
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,4CAA4C;EAC5C,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,yBAAyB;EACzB,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;;EAElC,0CAA0C;EAC1C,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,mCAAmC;;EAEnC,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,iCAAiC;;EAEjC,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,mCAAmC;;EAEnC,sDAAsD;EAEtD,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,mBAAmB;EACnB,0BAA0B;EAC1B,mCAAmC;EACnC,mCAAmC;;EAEnC,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;;EAEhC,kBAAkB;EAClB,+CAA+C;EAC/C,mFAAmF;EACnF,yFAAyF;EACzF,2FAA2F;EAC3F,4FAA4F;EAC5F,sDAAsD;;EAEtD,eAAe;EACf,gDAAgD;EAChD,qDAAqD;;EAErD,cAAc;EACd,mFAAmF;EACnF,2FAA2F;;EAE3F,iCAAiC;EACjC,kBAAkB,GAAG,QAAQ;EAC7B,iBAAiB,IAAI,QAAQ;EAC7B,kBAAkB,GAAG,SAAS;EAC9B,eAAe,MAAM,SAAS;EAC9B,kBAAkB,GAAG,SAAS;EAC9B,iBAAiB,IAAI,SAAS;EAC9B,eAAe,MAAM,SAAS;EAC9B,kBAAkB,GAAG,SAAS;EAC9B,gBAAgB,KAAK,SAAS;EAC9B,gBAAgB,KAAK,SAAS;;EAE9B,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;;EAErB,mDAAmD;EACnD,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;;EAElB,2BAA2B;EAC3B,kDAAkD;EAClD,uDAAuD;EACvD,yDAAyD;;EAEzD,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;;EAEvB,qBAAqB;EACrB,2CAA2C;EAC3C,sCAAsC;EACtC,qCAAqC;EACrC,qDAAqD;AACvD;;AAEA;EACE,SAAS;EACT,UAAU;EACV;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,0CAA0C;EAC1C,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,2CAA2C;EAC3C,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,2CAA2C;EAC3C,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,uDAAuD;AACzD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA,6BAA6B;AAC7B;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,SAAO;AACT;AACA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,aAAa;EACb,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,iCAAiC;EACjC,YAAY;EACZ,sCAAsC;EACtC,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,oCAAoC;EACpC,8FAA8F;AAChG;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,oCAAoC;AACpC;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;EAChB,6BAA6B;EAC7B,iDAAiD;AACnD;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,iDAAiD;EACjD,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,mFAAmF;EACnF,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,mFAAmF;AACrF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,iFAAiF;EACjF,YAAY;EACZ,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,iFAAiF;EACjF,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,iFAAiF;AACnF;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;EACxC,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,gEAAgE;EAChE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,qEAAqE;AACvE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,iDAAiD;EACjD,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,+BAA+B;EAC/B,wCAAwC;EACxC,eAAe;EACf,iDAAiD;EACjD,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,+BAA+B;EAC/B,wCAAwC;EACxC,eAAe;EACf,iDAAiD;EACjD,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;EACtB,eAAe;EACf,iDAAiD;EACjD,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,wCAAwC;EACxC,qCAAqC;EACrC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,4CAA4C;EAC5C,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,0CAA0C;AAC1C;EACE,4CAA4C;EAC5C,iDAAiD;EACjD,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,8EAA8E;EAC9E,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,mFAAmF;EACnF,2BAA2B;EAC3B,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,gFAAgF;AAClF;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,iDAAiD;EACjD,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,iDAAiD;EACjD,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,kBAAkB;EAClB,iDAAiD;EACjD,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,8EAA8E;EAC9E,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,mFAAmF;EACnF,0BAA0B;EAC1B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,kGAAkG;EAClG,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,uGAAuG;AACzG;;AAEA;EACE,qDAAqD;AACvD;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,wCAAwC;AACxC;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;IACV,WAAW;EACb;EACA;IACE,wBAAwB;IACxB,UAAU;IACV,QAAQ;EACV;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,oEAAoE;EACtE;EACA;IACE,sBAAsB;IACtB,oEAAoE;EACtE;EACA;IACE,mEAAmE;EACrE;EACA;IACE,kEAAkE;EACpE;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sCAAsC;AACtC;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,yDAAyD;AAC3D;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;EACR,mCAAmC;EACnC,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,sCAAsC;EACtC,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,sDAAsD;AACxD;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,4CAA4C;AAC5C;;;EAGE,aAAa;EACb,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;;EAGE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;EAC/B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,QAAQ;AACV;;AAEA,+BAA+B;AAC/B;EACE;IACE,iCAAiC;IACjC,iCAAiC;EACnC;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA,iCAAiC;AACjC;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;IACd,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,uCAAuC;EACvC,0BAA0B;EAC1B,iDAAiD;EACjD,2DAA2D;AAC7D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,qBAAqB;IACrB,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,wCAAwC;EACxC,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,wBAAwB;EACxB,iDAAiD;EACjD,qCAAqC;EACrC,oDAAoD;AACtD;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;EAC3C,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,2CAA2C;AAC3C;EACE,qDAAqD;AACvD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,0CAA0C;AAC1C;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,8BAA8B;AAC9B;EACE,qFAAqF;EACrF,yCAAyC;AAC3C;;AAEA;EACE,6EAA6E;AAC/E;;AAEA,+BAA+B;AAC/B,uCAAuC;AACvC,+BAA+B;;AAE/B,6BAA6B;AAC7B,gCAAgC;AAChC,gCAAgC;AAChC,2BAA2B;AAC3B,qBAAqB;;AAErB,uBAAuB;AACvB;EACE,8BAA8B;EAC9B;IACE,sCAAsC;EACxC;;EAEA,wBAAwB;EACxB;IACE,6BAA6B;IAC7B,+BAA+B;IAC/B,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA,4BAA4B;EAC5B;IACE,UAAU;IACV,6BAA6B;EAC/B;;EAEA,oCAAoC;EACpC;IACE,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,4CAA4C;IAC5C,+BAA+B;IAC/B,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA,+BAA+B;EAC/B;IACE,uCAAuC;IACvC,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,mCAAmC;IACnC,YAAY;IACZ,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,6BAA6B;EAC/B;;EAEA,6BAA6B;EAC7B;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,sBAAsB;EACtB;IACE,gBAAgB,EAAE,kCAAkC;IACpD,oBAAoB,EAAE,gCAAgC;IACtD,mBAAmB;EACrB;;EAEA,wBAAwB;EACxB;IACE,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,kCAAkC;IAClC,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE,sCAAsC;IACtC,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;IACE,kBAAkB;EACpB;;EAEA,uCAAuC;EACvC;IACE,gBAAgB;IAChB,iDAAiD;IACjD,4CAA4C;EAC9C;;EAEA;IACE,gCAAgC;IAChC,4CAA4C;IAC5C,eAAe,EAAE,6CAA6C;EAChE;;EAEA;IACE,qFAAqF;IACrF,yCAAyC;EAC3C;;EAEA;IACE,6EAA6E;EAC/E;;EAEA,wCAAwC;EACxC;IACE,sCAAsC;IACtC,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA,qCAAqC;EACrC;;IAEE,uBAAuB;IACvB,oBAAoB;IACpB,gBAAgB,EAAE,2BAA2B;EAC/C;;EAEA,6CAA6C;EAC7C;;IAEE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,sCAAsC;IACtC,+BAA+B;IAC/B,eAAe;IACf,iDAAiD;EACnD;;EAEA;;IAEE,gCAAgC;IAChC,mCAAmC;IACnC,qBAAqB;EACvB;;EAEA;;IAEE,oCAAoC;IACpC,gCAAgC;EAClC;;EAEA,2CAA2C;EAC3C;IACE,eAAe;IACf,+BAA+B;IAC/B,WAAW;IACX,gBAAgB,EAAE,2BAA2B;IAC7C,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iCAAiC;IACjC,eAAe,EAAE,6BAA6B;IAC9C,4CAA4C;EAC9C;;EAEA;IACE,mCAAmC;IACnC,8CAA8C;IAC9C,+BAA+B;IAC/B,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,uBAAuB;EACzB;;EAEA,0CAA0C;EAC1C;IACE,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;IACnB,+BAA+B;IAC/B,eAAe;IACf,iDAAiD;EACnD;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA,yCAAyC;EACzC;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iDAAiD;EACnD;;EAEA;IACE,iCAAiC;IACjC,sBAAsB;IACtB,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mCAAmC;IACnC,yBAAyB;EAC3B;;EAEA;IACE,kCAAkC;IAClC,wBAAwB;EAC1B;;EAEA,mCAAmC;EACnC;IACE,gBAAgB;IAChB,sCAAsC;IACtC,oBAAoB;IACpB,gBAAgB;IAChB,iCAAiC;IACjC,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,sCAAsC;IACtC,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,0CAA0C;EAC1C;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;IAC/B,sCAAsC;IACtC,iDAAiD;EACnD;;EAEA;IACE,gCAAgC;IAChC,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA,6BAA6B;EAC7B;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,+BAA+B;IAC/B,oCAAoC;IACpC,4BAA4B;EAC9B;;EAEA;IACE,gCAAgC;IAChC,6BAA6B;EAC/B;;EAEA,yBAAyB;EACzB;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,sCAAsC;EACxC;;EAEA,8BAA8B;EAC9B;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,+BAA+B;EACjC;;EAEA;IACE,gBAAgB;IAChB,SAAO;IACP,sCAAsC;IACtC,+BAA+B;EACjC;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,iDAAiD;EACnD;;EAEA;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA,wBAAwB;EACxB;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA,wBAAwB;EACxB;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,+BAA+B;IAC/B,mCAAmC;IACnC,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,oCAAoC;IACpC,YAAY;IACZ,0CAA0C;IAC1C,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,oCAAoC;IACpC,2BAA2B;EAC7B;;EAEA,+BAA+B;EAC/B;IACE,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,oDAAoD;IACpD,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,uBAAuB;EACzB;;EAEA,0CAA0C;EAC1C;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA,yBAAyB;EACzB;IACE,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,iDAAiD;EACnD;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,0BAA0B;EAC1B;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA,qCAAqC;EACrC;IACE,UAAU;EACZ;;EAEA;IACE,eAAe,EAAE,6BAA6B;EAChD;;EAEA,wBAAwB;EACxB;IACE,mCAAmC;IACnC,8CAA8C;EAChD;;EAEA;IACE,mCAAmC;IACnC,8CAA8C;EAChD;;EAEA,kCAAkC;EAClC;IACE,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA,oCAAoC;EACpC;;IAEE,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,+BAA+B;EACjC;;EAEA;IACE,kCAAkC;IAClC,wBAAwB;IACxB,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;IACnC,yBAAyB;IACzB,oCAAoC;EACtC;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,sCAAsC;EACxC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,sCAAsC;IACtC,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,sCAAsC;EACxC;;EAEA;IACE,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,sCAAsC;EACxC;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,sCAAsC;IACtC,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;IAC/B,gBAAgB;EAClB;AACF;;AAEA,oEAAoE;AACpE;EACE;IACE,gBAAgB,EAAE,8CAA8C;EAClE;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,2CAA2C;EAC3C;IACE,gCAAgC;IAChC,2BAA2B;IAC3B,8EAA8E;EAChF;;EAEA;IACE,iCAAiC;IACjC,0BAA0B;IAC1B,8EAA8E;EAChF;;EAEA;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,+BAA+B;AAC/B;EACE,0CAA0C;EAC1C;IACE,wCAAwC;IACxC,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,wCAAwC;IACxC,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,wCAAwC;EAC1C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,4BAA4B;EAC5B;IACE,iCAAiC;IACjC,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;IACpC,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,WAAW;EACb;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,sCAAsC;EACxC;;EAEA;IACE,YAAY;IACZ,sCAAsC;IACtC,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,sCAAsC;IACtC,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,sCAAsC;EACxC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,sCAAsC;EACxC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,sDAAsD;AACtD;EACE;IACE,sCAAsC;EACxC;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,sCAAsC;IACtC,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,sCAAsC;IACtC,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE;MACE,2BAA2B;IAC7B;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,iCAAiC;IACnC;;IAEA;MACE,iCAAiC;IACnC;;IAEA;MACE,iCAAiC;IACnC;;IAEA;MACE,iCAAiC;MACjC,6BAA6B;MAC7B,sBAAsB;IACxB;;IAEA;MACE,gCAAgC;MAChC,iCAAiC;IACnC;;IAEA;MACE,iCAAiC;MACjC,6BAA6B;IAC/B;;IAEA;MACE,mCAAmC;MACnC,wBAAwB;MACxB,+BAA+B;IACjC;;IAEA;MACE,oCAAoC;MACpC,yBAAyB;MACzB,gCAAgC;IAClC;EACF;AACF;;AAEA,0CAA0C;AAC1C;EACE,qBAAqB;EACrB;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA,4CAA4C;EAC5C;IACE,yCAAyC;EAC3C;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA,mDAAmD;AACnD;EACE;;;;;;IAME,oFAAoF;EACtF;;EAEA,yCAAyC;EACzC;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,WAAW;IACX,2EAA2E;IAC3E,oBAAoB;IACpB,UAAU;IACV,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,UAAU;IACV,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,sCAAsC;EACxC;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* Modern FinStack Design System */\n:root {\n  /* Primary Colors - Modern blue with depth */\n  --primary-50: #eff6ff;\n  --primary-100: #dbeafe;\n  --primary-200: #bfdbfe;\n  --primary-300: #93c5fd;\n  --primary-400: #60a5fa;\n  --primary-500: #3b82f6;\n  --primary-600: #2563eb;\n  --primary-700: #1d4ed8;\n  --primary-800: #1e40af;\n  --primary-900: #1e3a8a;\n  --primary-950: #172554;\n  \n  /* Legacy compatibility */\n  --primary-color: var(--primary-500);\n  --primary-dark: var(--primary-600);\n  --primary-light: var(--primary-50);\n  \n  /* Semantic Colors - Enhanced with depth */\n  --success-50: #f0fdf4;\n  --success-100: #dcfce7;\n  --success-200: #bbf7d0;\n  --success-500: #22c55e;\n  --success-600: #16a34a;\n  --success-700: #15803d;\n  --success-800: #166534;\n  --success-color: var(--success-500);\n  \n  --danger-50: #fef2f2;\n  --danger-100: #fee2e2;\n  --danger-200: #fecaca;\n  --danger-500: #ef4444;\n  --danger-600: #dc2626;\n  --danger-700: #b91c1c;\n  --danger-800: #991b1b;\n  --danger-color: var(--danger-500);\n  \n  --warning-50: #fffbeb;\n  --warning-100: #fef3c7;\n  --warning-200: #fde68a;\n  --warning-500: #f59e0b;\n  --warning-600: #d97706;\n  --warning-700: #b45309;\n  --warning-800: #92400e;\n  --warning-color: var(--warning-500);\n  \n  /* Modern Gray Scale - Warmer and more sophisticated */\n  --gray-25: #fcfcfd;\n  --gray-50: #f9fafb;\n  --gray-100: #f2f4f7;\n  --gray-200: #e4e7ec;\n  --gray-300: #d0d5dd;\n  --gray-400: #98a2b3;\n  --gray-500: #667085;\n  --gray-600: #475467;\n  --gray-700: #344054;\n  --gray-800: #1d2939;\n  --gray-900: #101828;\n  --gray-950: #0c111d;\n  \n  /* Surface Colors */\n  --surface-primary: #ffffff;\n  --surface-secondary: var(--gray-50);\n  --surface-tertiary: var(--gray-100);\n  \n  /* Border Colors */\n  --border-light: var(--gray-200);\n  --border-medium: var(--gray-300);\n  --border-strong: var(--gray-400);\n  \n  /* Shadow System */\n  --shadow-xs: 0 1px 2px 0 rgba(16, 24, 40, 0.05);\n  --shadow-sm: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.10);\n  --shadow-md: 0 2px 4px -2px rgba(16, 24, 40, 0.06), 0 4px 8px -2px rgba(16, 24, 40, 0.10);\n  --shadow-lg: 0 4px 6px -2px rgba(16, 24, 40, 0.03), 0 10px 15px -3px rgba(16, 24, 40, 0.10);\n  --shadow-xl: 0 8px 10px -3px rgba(16, 24, 40, 0.04), 0 20px 25px -5px rgba(16, 24, 40, 0.10);\n  --shadow-2xl: 0 25px 50px -12px rgba(16, 24, 40, 0.25);\n  \n  /* Focus Ring */\n  --focus-ring: 0 0 0 3px rgba(59, 130, 246, 0.12);\n  --focus-ring-error: 0 0 0 3px rgba(239, 68, 68, 0.12);\n  \n  /* Gradients */\n  --gradient-subtle: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);\n  --gradient-primary: linear-gradient(135deg, var(--primary-500) 0%, var(--primary-600) 100%);\n  \n  /* Spacing Scale - 4px/8px grid */\n  --space-1: 0.25rem;  /* 4px */\n  --space-2: 0.5rem;   /* 8px */\n  --space-3: 0.75rem;  /* 12px */\n  --space-4: 1rem;     /* 16px */\n  --space-5: 1.25rem;  /* 20px */\n  --space-6: 1.5rem;   /* 24px */\n  --space-8: 2rem;     /* 32px */\n  --space-10: 2.5rem;  /* 40px */\n  --space-12: 3rem;    /* 48px */\n  --space-16: 4rem;    /* 64px */\n  \n  /* Border Radius */\n  --radius-xs: 0.125rem;\n  --radius-sm: 0.25rem;\n  --radius-md: 0.375rem;\n  --radius-lg: 0.5rem;\n  --radius-xl: 0.75rem;\n  --radius-2xl: 1rem;\n  --radius-full: 9999px;\n  \n  /* Additional color variables for enhanced states */\n  --primary-25: #f8faff;\n  --success-25: #f7fef9;\n  --danger-25: #fffbfa;\n  --warning-25: #fffcf5;\n  --gray-25: #fcfcfd;\n  \n  /* Enhanced shadow system */\n  --shadow-focus: 0 0 0 3px rgba(59, 130, 246, 0.12);\n  --shadow-focus-error: 0 0 0 3px rgba(239, 68, 68, 0.12);\n  --shadow-focus-success: 0 0 0 3px rgba(34, 197, 94, 0.12);\n  \n  /* Animation timings */\n  --duration-fast: 0.15s;\n  --duration-normal: 0.2s;\n  --duration-slow: 0.3s;\n  --duration-slower: 0.5s;\n  \n  /* Easing functions */\n  --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n  --ease-out: cubic-bezier(0, 0, 0.2, 1);\n  --ease-in: cubic-bezier(0.4, 0, 1, 1);\n  --ease-bounce: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--surface-secondary);\n  color: var(--gray-800);\n  line-height: 1.6;\n  letter-spacing: -0.01em;\n}\n\n/* Layout styles */\n.app-container {\n  display: flex;\n  min-height: 100vh;\n}\n\n.sidebar {\n  width: 250px;\n  min-width: 250px;\n  max-width: 250px;\n  background-color: var(--surface-primary);\n  border-right: 1px solid var(--border-light);\n  display: none;\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n  position: relative;\n  flex-shrink: 0;\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@media (min-width: 768px) {\n  .sidebar {\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n  }\n}\n\n.sidebar-mobile {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 250px;\n  height: 100vh;\n  background-color: var(--surface-primary);\n  border-right: 1px solid var(--border-light);\n  box-shadow: var(--shadow-lg);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  transform: translateX(-100%);\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar-mobile.sidebar-open {\n  transform: translateX(0);\n}\n\n.sidebar-logo {\n  padding: var(--space-4);\n  border-bottom: 1px solid var(--border-light);\n  font-weight: 700;\n  font-size: 1.25rem;\n  color: var(--primary-600);\n  letter-spacing: -0.02em;\n}\n\n.sidebar-nav {\n  flex: 1;\n  padding: 1rem 0;\n  overflow-y: auto;\n}\n\n.sidebar-nav-item {\n  display: flex;\n  align-items: center;\n  padding: var(--space-3) var(--space-4);\n  color: var(--gray-600);\n  text-decoration: none;\n  margin-bottom: var(--space-1);\n  border-radius: var(--radius-md);\n  margin-left: var(--space-2);\n  margin-right: var(--space-2);\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  font-weight: 500;\n}\n\n.sidebar-nav-item:hover {\n  background-color: var(--gray-100);\n  color: var(--gray-700);\n  transform: translateX(2px);\n}\n\n.sidebar-nav-item.active {\n  background-color: var(--primary-50);\n  color: var(--primary-600);\n  font-weight: 600;\n  box-shadow: inset 3px 0 0 var(--primary-500);\n}\n\n.sidebar-nav-item svg {\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-right: 0.75rem;\n}\n\n.sidebar-footer {\n  padding: var(--space-4);\n  border-top: 1px solid var(--border-light);\n}\n\n/* Collapsed Sidebar Styles */\n.sidebar-collapsed {\n  width: 72px !important;\n  min-width: 72px !important;\n  max-width: 72px !important;\n}\n.sidebar-collapsed .sidebar-logo {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-4);\n}\n.sidebar-collapsed .sidebar-logo .flex {\n  justify-content: center;\n  flex: 1;\n}\n.sidebar-collapsed .sidebar-nav-item {\n  padding: var(--space-3) var(--space-4);\n  justify-content: center;\n  position: relative;\n  margin-left: var(--space-1);\n  margin-right: var(--space-1);\n  min-height: 44px;\n}\n.sidebar-collapsed .sidebar-nav-item svg {\n  margin-right: 0;\n  width: 1.5rem;\n  height: 1.5rem;\n}\n.sidebar-collapsed .sidebar-footer {\n  padding: var(--space-3);\n  display: flex;\n  justify-content: center;\n}\n.sidebar-collapsed .sidebar-footer .flex {\n  justify-content: center;\n}\n\n/* Tooltip for collapsed sidebar */\n.sidebar-collapsed .sidebar-nav-item:hover::after {\n  content: attr(title);\n  position: absolute;\n  left: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: var(--gray-800);\n  color: white;\n  padding: var(--space-2) var(--space-3);\n  border-radius: var(--radius-md);\n  font-size: 0.875rem;\n  white-space: nowrap;\n  z-index: 1000;\n  margin-left: var(--space-2);\n  box-shadow: var(--shadow-lg);\n  pointer-events: none;\n}\n\n/* Organization Switcher Styles */\n.org-switcher-container {\n  width: 100%;\n  position: relative;\n}\n\n.org-switcher-container .dropdown-menu {\n  max-width: 14rem;\n  width: auto;\n  background-color: #ffffff !important;\n  border: 1px solid #e5e7eb !important;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;\n}\n\n.sidebar-collapsed .org-switcher-container .dropdown-menu {\n  max-width: 12rem;\n}\n\n/* Ensure dropdown items are visible */\n.org-switcher-container .dropdown-item {\n  color: #374151 !important;\n  background-color: transparent;\n}\n\n.org-switcher-container .dropdown-item:hover {\n  background-color: #f3f4f6 !important;\n}\n\n/* Sidebar User Information Styles */\n.sidebar-footer .btn {\n  transition: all 0.2s ease-in-out;\n}\n\n.sidebar-footer .btn:hover {\n  background-color: var(--gray-100);\n  transform: translateY(-1px);\n}\n\n.sidebar-footer .btn:active {\n  transform: translateY(0);\n}\n\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  margin-left: 250px;\n  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@media (max-width: 767px) {\n  .main-content {\n    margin-left: 0;\n  }\n}\n\n.sidebar-collapsed ~ .main-content {\n  margin-left: 72px;\n}\n\n.content-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: auto;\n}\n\n.header {\n  height: 64px;\n  background-color: var(--surface-primary);\n  border-bottom: 1px solid var(--border-light);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 var(--space-4);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  box-shadow: var(--shadow-sm);\n  backdrop-filter: blur(8px);\n}\n\n.page-content {\n  flex: 1;\n  padding: var(--space-6);\n}\n\n/* Card styles */\n.card {\n  background-color: var(--surface-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-light);\n  overflow: hidden;\n  margin-bottom: var(--space-6);\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.card:hover {\n  box-shadow: var(--shadow-lg);\n  transform: translateY(-2px);\n}\n\n.card-header {\n  padding: var(--space-4) var(--space-5);\n  border-bottom: 1px solid var(--border-light);\n  font-weight: 600;\n  font-size: 1.125rem;\n  color: var(--gray-800);\n  background: var(--gradient-subtle);\n  letter-spacing: -0.01em;\n}\n\n.card-body {\n  padding: var(--space-5);\n}\n\n.card-footer {\n  padding: var(--space-4) var(--space-5);\n  border-top: 1px solid var(--border-light);\n  background-color: var(--surface-tertiary);\n}\n\n/* Button styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-2) var(--space-4);\n  font-size: 0.875rem;\n  font-weight: 500;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 1px solid transparent;\n  text-decoration: none;\n  position: relative;\n  overflow: hidden;\n  letter-spacing: -0.01em;\n}\n\n.btn:focus {\n  outline: none;\n  box-shadow: var(--focus-ring);\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.btn-primary {\n  background: var(--gradient-primary);\n  color: white;\n  border: 1px solid var(--primary-600);\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-primary:hover {\n  background: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-700) 100%);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.btn-primary:active {\n  transform: translateY(0);\n  box-shadow: var(--shadow-sm);\n  background: linear-gradient(135deg, var(--primary-700) 0%, var(--primary-800) 100%);\n}\n\n.btn-primary.loading {\n  cursor: not-allowed;\n  color: transparent;\n}\n\n.btn-primary.loading::after {\n  content: '';\n  position: absolute;\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid transparent;\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.btn-secondary {\n  background-color: var(--surface-primary);\n  color: var(--gray-700);\n  border: 1px solid var(--border-medium);\n  box-shadow: var(--shadow-xs);\n}\n\n.btn-secondary:hover {\n  background-color: var(--gray-50);\n  border-color: var(--border-strong);\n  box-shadow: var(--shadow-sm);\n  transform: translateY(-1px);\n}\n\n.btn-secondary:active {\n  transform: translateY(0);\n  box-shadow: var(--shadow-xs);\n  background-color: var(--gray-100);\n}\n\n.btn-sm {\n  padding: var(--space-1) var(--space-3);\n  font-size: 0.75rem;\n}\n\n.btn-text {\n  background: none;\n  border: none;\n  color: var(--gray-600);\n  padding: var(--space-1) var(--space-2);\n  font-size: 0.875rem;\n}\n\n.btn-text:hover {\n  color: var(--gray-700);\n  background-color: var(--gray-100);\n  transform: translateY(-1px);\n}\n\n.btn-text:active {\n  color: var(--gray-800);\n  background-color: var(--gray-200);\n  transform: translateY(0);\n}\n\n.btn-danger {\n  background: linear-gradient(135deg, var(--danger-500) 0%, var(--danger-600) 100%);\n  color: white;\n  border: 1px solid var(--danger-600);\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-danger:hover {\n  background: linear-gradient(135deg, var(--danger-600) 0%, var(--danger-700) 100%);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.btn-danger:active {\n  transform: translateY(0);\n  box-shadow: var(--shadow-sm);\n  background: linear-gradient(135deg, var(--danger-700) 0%, var(--danger-800) 100%);\n}\n\n/* Form styles */\n.form-group {\n  margin-bottom: var(--space-4);\n}\n\n.form-label {\n  display: block;\n  margin-bottom: var(--space-2);\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--gray-700);\n  letter-spacing: -0.01em;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: var(--space-3) var(--space-3);\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: var(--gray-700);\n  background-color: var(--surface-primary);\n  border: 1px solid var(--border-medium);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-xs);\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  font-weight: 400;\n}\n\n.form-control::placeholder {\n  color: var(--gray-400);\n  opacity: 1;\n}\n\n.form-control:hover {\n  border-color: var(--border-strong);\n  box-shadow: 0 2px 4px rgba(16, 24, 40, 0.08);\n}\n\n.form-control:focus {\n  border-color: var(--primary-500);\n  outline: none;\n  box-shadow: var(--focus-ring), 0 2px 4px rgba(59, 130, 246, 0.1);\n  background-color: var(--surface-primary);\n  transform: translateY(-1px);\n}\n\n.form-control.error {\n  border-color: var(--danger-500);\n  box-shadow: var(--focus-ring-error);\n}\n\n.form-control.error:focus {\n  border-color: var(--danger-600);\n  box-shadow: var(--focus-ring-error), 0 2px 4px rgba(239, 68, 68, 0.1);\n}\n\n.amount-input-group {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.amount-input-group .form-control {\n  flex: 1;\n}\n\n.amount-input-group select {\n  min-width: 60px;\n  border-radius: var(--radius-sm);\n}\n\n/* Grid system */\n.grid {\n  display: grid;\n  grid-gap: var(--space-6);\n}\n\n.grid-cols-1 {\n  grid-template-columns: repeat(1, 1fr);\n}\n\n@media (min-width: 768px) {\n  .md\\\\:grid-cols-2 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .md\\\\:grid-cols-3 {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (min-width: 1024px) {\n  .lg\\\\:grid-cols-3 {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  \n  .lg\\\\:grid-cols-4 {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n/* Utility classes */\n.flex {\n  display: flex;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.space-x-4 > * + * {\n  margin-left: var(--space-4);\n}\n\n.space-y-4 > * + * {\n  margin-top: var(--space-4);\n}\n\n.text-sm {\n  font-size: 0.875rem;\n}\n\n.text-lg {\n  font-size: 1.125rem;\n}\n\n.text-xl {\n  font-size: 1.25rem;\n}\n\n.text-2xl {\n  font-size: 1.5rem;\n}\n\n.font-medium {\n  font-weight: 500;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.text-primary {\n  color: var(--primary-color);\n}\n\n.text-success {\n  color: var(--success-color);\n}\n\n.text-danger {\n  color: var(--danger-color);\n}\n\n.text-warning {\n  color: var(--warning-color);\n}\n\n.text-success {\n  color: var(--success-color);\n}\n\n/* Transaction Styles */\n.transactions-container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n}\n\n.transactions-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--space-4);\n}\n\n.page-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--gray-800);\n  margin: 0;\n}\n\n.filter-card {\n  margin-bottom: var(--space-6);\n}\n\n.filter-card.compact {\n  padding-bottom: var(--space-3);\n}\n\n.filter-header {\n  margin-bottom: var(--space-3);\n}\n\n.filter-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--space-3);\n}\n\n.filter-title-container {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n}\n\n.filter-title {\n  font-size: 1.125rem;\n  font-weight: 500;\n  margin: 0;\n}\n\n.filter-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--gradient-primary);\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 600;\n  height: 1.25rem;\n  min-width: 1.25rem;\n  padding: 0 var(--space-2);\n  border-radius: var(--radius-full);\n  margin-left: var(--space-2);\n  box-shadow: var(--shadow-sm);\n}\n\n.filter-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  color: var(--gray-600);\n  font-size: 1.25rem;\n  font-weight: 600;\n  width: 1.5rem;\n  height: 1.5rem;\n  margin-left: var(--space-2);\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: var(--radius-sm);\n}\n\n.filter-toggle:hover {\n  background-color: var(--gray-100);\n  transform: scale(1.1);\n}\n\n.filter-toggle.expanded {\n  color: var(--primary-600);\n  background-color: var(--primary-50);\n}\n\n.search-container {\n  margin-bottom: var(--space-3);\n}\n\n.search-input {\n  width: 100%;\n  padding: var(--space-2) var(--space-3);\n  border-radius: var(--radius-md);\n}\n\n.filter-controls {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.filter-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  border-bottom: 1px solid var(--border-light);\n  padding-bottom: var(--space-3);\n}\n\n.filter-section {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-4);\n  width: 100%;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n}\n\n.filter-label {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--gray-600);\n  margin: 0;\n}\n\n.date-range-inputs {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.date-input {\n  width: 130px;\n  padding: var(--space-2) var(--space-2);\n  font-size: 0.875rem;\n}\n\n.date-separator {\n  font-size: 0.75rem;\n  color: var(--gray-500);\n}\n\n.status-select {\n  width: 130px;\n  padding: var(--space-2) var(--space-2);\n  font-size: 0.875rem;\n}\n\n.checkbox-group {\n  display: flex;\n  gap: var(--space-4);\n}\n\n.checkbox-label {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.checkbox-text {\n  margin-left: var(--space-2);\n  font-size: 0.875rem;\n  color: var(--gray-700);\n}\n\n/* Enhanced checkbox interactive states */\n.table-row input[type=\"checkbox\"] {\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid var(--border-medium);\n  border-radius: var(--radius-sm);\n  background-color: var(--surface-primary);\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  accent-color: var(--primary-600);\n}\n\n.table-row input[type=\"checkbox\"]:hover {\n  border-color: var(--primary-400);\n  background-color: var(--primary-25);\n  transform: scale(1.05);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);\n}\n\n.table-row input[type=\"checkbox\"]:focus {\n  outline: none;\n  border-color: var(--primary-500);\n  box-shadow: var(--focus-ring);\n}\n\n.table-row input[type=\"checkbox\"]:checked {\n  background-color: var(--primary-600);\n  border-color: var(--primary-600);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);\n}\n\n.table-row input[type=\"checkbox\"]:checked:hover {\n  background-color: var(--primary-700);\n  border-color: var(--primary-700);\n  transform: scale(1.05);\n}\n\n.table-header-cell input[type=\"checkbox\"] {\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  background-color: var(--surface-primary);\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  accent-color: var(--primary-600);\n}\n\n.table-header-cell input[type=\"checkbox\"]:hover {\n  border-color: var(--primary-400);\n  background-color: var(--primary-25);\n  transform: scale(1.05);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);\n}\n\n.table-header-cell input[type=\"checkbox\"]:focus {\n  outline: none;\n  border-color: var(--primary-500);\n  box-shadow: var(--focus-ring);\n}\n\n.table-header-cell input[type=\"checkbox\"]:checked {\n  background-color: var(--primary-600);\n  border-color: var(--primary-600);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);\n}\n\n.table-header-cell input[type=\"checkbox\"]:checked:hover {\n  background-color: var(--primary-700);\n  border-color: var(--primary-700);\n  transform: scale(1.05);\n}\n\n.filter-tags-container {\n  padding-bottom: var(--space-2);\n}\n\n.filter-tags-section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.filter-tags-group {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.tag-cloud {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n}\n\n@media (min-width: 768px) {\n  .filter-section {\n    flex-wrap: nowrap;\n  }\n  \n  .filter-tags-section {\n    flex-direction: row;\n  }\n  \n  .filter-tags-group {\n    flex: 1;\n  }\n}\n\n.category-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n}\n\n.category-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: var(--space-1) var(--space-3);\n  border-radius: var(--radius-full);\n  font-size: 0.75rem;\n  font-weight: 500;\n  background-color: var(--gray-100);\n  color: var(--gray-800);\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 1px solid var(--gray-200);\n  box-shadow: var(--shadow-xs);\n}\n\n.category-tag:hover {\n  background-color: var(--gray-200);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.category-tag-active {\n  background-color: var(--primary-100);\n  color: var(--primary-700);\n  border-color: var(--primary-300);\n  box-shadow: var(--shadow-sm);\n}\n\n.category-tag-active:hover {\n  background-color: var(--primary-200);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.transaction-card {\n  overflow: hidden;\n}\n\n.table-responsive {\n  overflow-x: auto;\n  margin-bottom: var(--space-6);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  background-color: var(--surface-primary);\n  border: 1px solid var(--border-light);\n  max-width: 100%;\n  width: 100%;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  white-space: nowrap;\n  table-layout: fixed;\n  min-width: 820px;\n}\n\n.table-header {\n  background: var(--gradient-subtle);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  backdrop-filter: blur(8px);\n}\n\n.table-header-cell {\n  padding: var(--space-3) var(--space-4);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--gray-600);\n  text-align: left;\n  border-bottom: 1px solid var(--border-light);\n  height: 52px;\n  background: var(--gradient-subtle);\n}\n\n.table-body {\n  background-color: var(--surface-primary);\n}\n\n/* Enhanced table row interactive states */\n.table-row {\n  border-bottom: 1px solid var(--border-light);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  background-color: var(--surface-primary);\n}\n\n.table-row:hover {\n  background-color: var(--gray-50);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.08), 0 1px 3px rgba(16, 24, 40, 0.12);\n  border-color: var(--gray-300);\n}\n\n.table-row.editing-row {\n  background-color: var(--primary-50);\n  box-shadow: inset 0 0 0 2px var(--primary-300), 0 4px 12px rgba(59, 130, 246, 0.15);\n  transform: translateY(-2px);\n  border-color: var(--primary-300);\n  z-index: 5;\n}\n\n.table-row.selected {\n  background-color: var(--primary-25);\n  box-shadow: inset 3px 0 0 var(--primary-500);\n  border-color: var(--primary-200);\n}\n\n.table-row.selected:hover {\n  background-color: var(--primary-50);\n  transform: translateY(-1px);\n  box-shadow: inset 3px 0 0 var(--primary-500), 0 2px 8px rgba(59, 130, 246, 0.12);\n}\n\n.table-cell {\n  padding: var(--space-3) var(--space-4);\n  vertical-align: middle;\n  color: var(--gray-700);\n  font-size: 0.875rem;\n  height: 60px;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.table-row.editing-row .table-cell {\n  padding: var(--space-2) var(--space-3);\n}\n\n.category-color-dot {\n  width: 0.5rem;\n  height: 0.5rem;\n  border-radius: 50%;\n  margin-right: var(--space-2);\n}\n\n/* Category styling */\n.category-display {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.category-color-dot {\n  display: inline-block;\n  width: 0.75rem;\n  height: 0.75rem;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n/* Enhanced badge interactive states */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  border-radius: var(--radius-full);\n  white-space: nowrap;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  letter-spacing: 0.01em;\n  border: 1px solid transparent;\n  cursor: default;\n}\n\n.badge.cursor-pointer {\n  cursor: pointer;\n}\n\n.badge.cursor-pointer:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(16, 24, 40, 0.12);\n}\n\n.badge.cursor-pointer:active {\n  transform: translateY(0);\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);\n}\n\n.badge-primary.cursor-pointer:hover {\n  background-color: var(--primary-200);\n  border-color: var(--primary-400);\n  color: var(--primary-800);\n}\n\n.badge-success.cursor-pointer:hover {\n  background-color: var(--success-200);\n  border-color: var(--success-400);\n  color: var(--success-800);\n}\n\n.badge-warning.cursor-pointer:hover {\n  background-color: var(--warning-200);\n  border-color: var(--warning-400);\n  color: var(--warning-800);\n}\n\n.badge-danger.cursor-pointer:hover {\n  background-color: var(--danger-200);\n  border-color: var(--danger-400);\n  color: var(--danger-800);\n}\n\n.badge-secondary.cursor-pointer:hover {\n  background-color: var(--gray-200);\n  border-color: var(--gray-400);\n  color: var(--gray-800);\n}\n\n.badge-info.cursor-pointer:hover {\n  background-color: var(--primary-200);\n  border-color: var(--primary-400);\n  color: var(--primary-800);\n}\n\n/* Badge sizes */\n.badge-sm {\n  padding: var(--space-1) var(--space-2);\n  font-size: 0.75rem;\n  line-height: 1.2;\n}\n\n.badge-md {\n  padding: var(--space-1) var(--space-3);\n  font-size: 0.8125rem;\n  line-height: 1.3;\n}\n\n.badge-lg {\n  padding: var(--space-2) var(--space-4);\n  font-size: 0.875rem;\n  line-height: 1.4;\n}\n\n/* Badge variants */\n.badge-primary {\n  background-color: var(--primary-100);\n  color: var(--primary-700);\n  border-color: var(--primary-200);\n}\n\n.badge-success {\n  background-color: var(--success-100);\n  color: var(--success-700);\n  border-color: var(--success-200);\n}\n\n.badge-warning {\n  background-color: var(--warning-100);\n  color: var(--warning-700);\n  border-color: var(--warning-200);\n}\n\n.badge-danger {\n  background-color: var(--danger-100);\n  color: var(--danger-700);\n  border-color: var(--danger-200);\n}\n\n.badge-secondary {\n  background-color: var(--gray-100);\n  color: var(--gray-700);\n  border-color: var(--gray-200);\n}\n\n.badge-info {\n  background-color: var(--primary-100);\n  color: var(--primary-600);\n  border-color: var(--primary-200);\n}\n\n/* Form control sizing */\n.form-control-sm {\n  padding: var(--space-1) var(--space-2);\n  font-size: 0.75rem;\n}\n\n/* Enhanced editable cell interactive states */\n.editable-cell {\n  cursor: pointer;\n  position: relative;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: var(--radius-sm);\n  margin: 2px;\n}\n\n.editable-cell:hover {\n  background-color: var(--gray-100);\n  transform: translateX(2px);\n  box-shadow: inset 3px 0 0 var(--primary-300), 0 2px 4px rgba(16, 24, 40, 0.08);\n  border-radius: var(--radius-sm);\n}\n\n.editable-cell.editing {\n  background-color: var(--primary-50);\n  box-shadow: inset 0 0 0 2px var(--primary-400), 0 4px 12px rgba(59, 130, 246, 0.15);\n  transform: translateX(4px);\n  border-radius: var(--radius-md);\n  z-index: 10;\n}\n\n.editable-cell.editing .form-control {\n  border: none;\n  box-shadow: none;\n  background-color: transparent;\n  color: var(--gray-800);\n  font-weight: 500;\n}\n\n.editable-cell.editing .form-control:focus {\n  box-shadow: none;\n  border-color: transparent;\n}\n\n.editable-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 1.5rem;\n}\n\n.editable-content .group {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n/* Actions cell styling */\n.actions-cell {\n  width: 80px;\n  min-width: 80px;\n  white-space: nowrap;\n  text-align: center;\n}\n\n/* Status column specific styling */\n.status-cell {\n  width: 120px;\n  min-width: 120px;\n  white-space: nowrap;\n}\n\n/* Amount cell styling */\n.amount-cell {\n  font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;\n  font-weight: 500;\n  text-align: right;\n}\n\n/* GL account search wrapper */\n.gl-account-search-wrapper {\n  position: relative;\n  z-index: 20;\n}\n\n.table-gl-search {\n  font-size: 0.875rem;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Enhanced modal styling */\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-6);\n  border-bottom: 1px solid var(--border-light);\n}\n\n.modal-body {\n  padding: var(--space-6);\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: var(--space-6);\n  border-top: 1px solid var(--border-light);\n  background: var(--gray-25);\n}\n\n/* Transition utilities */\n.transition-colors {\n  transition: color 0.2s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.transition-opacity {\n  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Opacity utilities */\n.opacity-0 {\n  opacity: 0;\n}\n\n.group:hover .group-hover\\:opacity-100 {\n  opacity: 1;\n}\n\n/* Utility classes for common patterns */\n.inline-flex {\n  display: inline-flex;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed;\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Enhanced animation keyframes */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes backdropFadeIn {\n  from {\n    opacity: 0;\n    backdrop-filter: blur(0px);\n  }\n  to {\n    opacity: 1;\n    backdrop-filter: blur(4px);\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(100px);\n    opacity: 0;\n    scale: 0.95;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n    scale: 1;\n  }\n}\n\n@keyframes slideDown {\n  from {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes expandIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n@keyframes dots {\n  0%, 20% {\n    color: rgba(0, 0, 0, 0);\n    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);\n  }\n  40% {\n    color: var(--gray-600);\n    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);\n  }\n  60% {\n    text-shadow: 0.25em 0 0 var(--gray-600), 0.5em 0 0 rgba(0, 0, 0, 0);\n  }\n  80%, 100% {\n    text-shadow: 0.25em 0 0 var(--gray-600), 0.5em 0 0 var(--gray-600);\n  }\n}\n\n@keyframes fadeInOut {\n  0%, 20% {\n    opacity: 0;\n  }\n  40%, 60% {\n    opacity: 0.8;\n  }\n  80%, 100% {\n    opacity: 0;\n  }\n}\n\n/* Enhanced loading state animations */\n.loading-spinner {\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid var(--gray-200);\n  border-radius: 50%;\n  border-top-color: var(--primary-600);\n  animation: spin 1s linear infinite;\n}\n\n.loading-spinner-sm {\n  width: 0.75rem;\n  height: 0.75rem;\n  border-width: 1.5px;\n}\n\n.loading-spinner-lg {\n  width: 1.5rem;\n  height: 1.5rem;\n  border-width: 3px;\n}\n\n.loading-dots {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1);\n}\n\n.loading-dots::after {\n  content: '';\n  animation: dots 1.5s linear infinite;\n}\n\n.pulse-loading {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n/* Enhanced selection state visual feedback */\n.selection-indicator {\n  position: relative;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.selection-indicator::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 0;\n  background: var(--gradient-primary);\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 1;\n}\n\n.selection-indicator.selected::before {\n  width: 3px;\n}\n\n.bulk-actions {\n  background: var(--gradient-primary);\n  color: white;\n  padding: var(--space-3) var(--space-4);\n  border-radius: var(--radius-lg);\n  margin-bottom: var(--space-4);\n  box-shadow: var(--shadow-lg);\n  animation: slideDown 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.bulk-actions .btn {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  backdrop-filter: blur(10px);\n}\n\n.bulk-actions .btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Enhanced focus styles for accessibility */\ninput:focus,\nselect:focus,\ntextarea:focus {\n  outline: none;\n  border-color: var(--primary-500);\n  box-shadow: var(--focus-ring);\n  transform: translateY(-1px);\n}\n\ninput:focus-visible,\nselect:focus-visible,\ntextarea:focus-visible {\n  outline: 2px solid var(--primary-500);\n  outline-offset: 2px;\n}\n\nbutton:focus-visible {\n  outline: 2px solid var(--primary-500);\n  outline-offset: 2px;\n}\n\n/* Custom focus styles for table interactions */\n.table-row:focus-within {\n  background-color: var(--primary-25);\n  box-shadow: inset 0 0 0 2px var(--primary-200);\n}\n\n.editable-cell:focus-within {\n  background-color: var(--primary-50);\n  box-shadow: inset 0 0 0 2px var(--primary-300);\n  border-radius: var(--radius-sm);\n}\n\n/* Enhanced accessibility helpers */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.focus-trap {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n}\n\n.focus-visible {\n  outline: 2px solid var(--primary-500);\n  outline-offset: 2px;\n}\n\n.skip-link {\n  position: absolute;\n  top: -40px;\n  left: 6px;\n  background: var(--primary-600);\n  color: white;\n  padding: 8px;\n  text-decoration: none;\n  border-radius: var(--radius-sm);\n  z-index: 100;\n  transition: top 0.2s;\n}\n\n.skip-link:focus {\n  top: 6px;\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .table-row:hover {\n    background-color: var(--gray-200);\n    border: 2px solid var(--gray-600);\n  }\n  \n  .btn:focus {\n    outline: 3px solid var(--primary-600);\n    outline-offset: 2px;\n  }\n  \n  .form-control:focus {\n    outline: 2px solid var(--primary-600);\n    outline-offset: 1px;\n  }\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* Table specific hover effects */\n.table-row:hover .editable-cell {\n  background-color: var(--gray-50);\n}\n\n.table-row:hover .group .group-hover\\:opacity-100 {\n  opacity: 1;\n}\n\n/* Empty state styling */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-12) var(--space-4);\n  text-align: center;\n}\n\n.btn-icon {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  padding: var(--space-1);\n  border-radius: var(--radius-sm);\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-icon:hover {\n  background-color: var(--gray-100);\n  transform: scale(1.1);\n  box-shadow: 0 2px 4px rgba(16, 24, 40, 0.1);\n}\n\n.btn-icon:active {\n  transform: scale(0.95);\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.1);\n}\n\n.btn-icon:focus {\n  outline: none;\n  box-shadow: var(--focus-ring);\n}\n\n.btn-edit {\n  color: var(--primary-600);\n}\n\n.btn-edit:hover {\n  color: var(--primary-700);\n  background-color: var(--primary-50);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.15);\n}\n\n.btn-edit:active {\n  color: var(--primary-800);\n  background-color: var(--primary-100);\n}\n\n.btn-delete {\n  color: var(--danger-600);\n}\n\n.btn-delete:hover {\n  color: var(--danger-700);\n  background-color: var(--danger-50);\n  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.15);\n}\n\n.btn-delete:active {\n  color: var(--danger-800);\n  background-color: var(--danger-100);\n}\n\n.btn-link {\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 0.875rem;\n  color: var(--primary-600);\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.btn-link:hover {\n  color: var(--primary-700);\n  text-decoration-color: var(--primary-700);\n}\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 50;\n  overflow-y: auto;\n  animation: fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.modal-container {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  min-height: 100vh;\n  padding: var(--space-4);\n  text-align: center;\n}\n\n@media (min-width: 640px) {\n  .modal-container {\n    display: block;\n    padding: 0;\n  }\n}\n\n.modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(16, 24, 40, 0.7);\n  backdrop-filter: blur(4px);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  animation: backdropFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.modal-helper {\n  display: none;\n}\n\n@media (min-width: 640px) {\n  .modal-helper {\n    display: inline-block;\n    height: 100vh;\n    vertical-align: middle;\n  }\n}\n\n.modal-content {\n  display: inline-block;\n  vertical-align: bottom;\n  background-color: var(--surface-primary);\n  border-radius: var(--radius-xl);\n  text-align: left;\n  overflow: hidden;\n  box-shadow: var(--shadow-2xl);\n  transform: translateY(0);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 1px solid var(--border-light);\n  animation: slideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.modal-content:hover {\n  box-shadow: var(--shadow-2xl), 0 0 0 1px rgba(59, 130, 246, 0.1);\n}\n\n@media (min-width: 640px) {\n  .modal-content {\n    vertical-align: middle;\n    margin: var(--space-8) auto;\n    max-width: 32rem;\n    width: 100%;\n  }\n}\n\n.text-gray-400 {\n  color: var(--gray-400);\n}\n\n/* Loading container for code splitting */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  font-size: 1.25rem;\n  color: var(--primary-600);\n  background-color: rgba(255, 255, 255, 0.95);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  backdrop-filter: blur(8px);\n}\n\n.text-gray-500 {\n  color: var(--gray-500);\n}\n\n.text-gray-600 {\n  color: var(--gray-600);\n}\n\n.text-gray-700 {\n  color: var(--gray-700);\n}\n\n.text-gray-800 {\n  color: var(--gray-800);\n}\n\n.bg-white {\n  background-color: white;\n}\n\n.bg-primary {\n  background-color: var(--primary-color);\n}\n\n.bg-success {\n  background-color: var(--success-color);\n}\n\n.bg-danger {\n  background-color: var(--danger-color);\n}\n\n.bg-warning {\n  background-color: var(--warning-color);\n}\n\n.rounded {\n  border-radius: var(--radius-sm);\n}\n\n.rounded-full {\n  border-radius: var(--radius-full);\n}\n\n.shadow-sm {\n  box-shadow: var(--shadow-sm);\n}\n\n.p-1 {\n  padding: var(--space-1);\n}\n\n.p-2 {\n  padding: var(--space-2);\n}\n\n.p-4 {\n  padding: var(--space-4);\n}\n\n.px-4 {\n  padding-left: var(--space-4);\n  padding-right: var(--space-4);\n}\n\n.py-2 {\n  padding-top: var(--space-2);\n  padding-bottom: var(--space-2);\n}\n\n.py-4 {\n  padding-top: var(--space-4);\n  padding-bottom: var(--space-4);\n}\n\n.m-2 {\n  margin: var(--space-2);\n}\n\n.m-4 {\n  margin: var(--space-4);\n}\n\n.mb-2 {\n  margin-bottom: var(--space-2);\n}\n\n.mb-4 {\n  margin-bottom: var(--space-4);\n}\n\n.mt-2 {\n  margin-top: var(--space-2);\n}\n\n.mt-4 {\n  margin-top: var(--space-4);\n}\n\n.w-full {\n  width: 100%;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.hidden {\n  display: none;\n}\n\n@media (min-width: 768px) {\n  .md\\\\:block {\n    display: block;\n  }\n  \n  .md\\\\:flex {\n    display: flex;\n  }\n  \n  .md\\\\:hidden {\n    display: none;\n  }\n}\n\n/* Enhanced micro-interactions and polish */\n.edit-actions {\n  animation: fadeInUp 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.table-cell .editable-content {\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.table-cell .editable-content:hover {\n  padding-left: var(--space-2);\n}\n\n.gl-account-search-wrapper {\n  animation: expandIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.category-display {\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.category-display:hover {\n  transform: translateX(2px);\n}\n\n.category-color-dot {\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.category-display:hover .category-color-dot {\n  transform: scale(1.2);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.transaction-card {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.transaction-card:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-lg);\n}\n\n.error-message {\n  color: var(--danger-600);\n  font-size: 0.75rem;\n  margin-top: var(--space-1);\n  animation: slideIn 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.success-message {\n  color: var(--success-600);\n  font-size: 0.75rem;\n  margin-top: var(--space-1);\n  animation: slideIn 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.ripple {\n  position: relative;\n  overflow: hidden;\n}\n\n.ripple::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.5);\n  transition: width 0.6s, height 0.6s;\n  transform: translate(-50%, -50%);\n}\n\n.ripple:active::before {\n  width: 300px;\n  height: 300px;\n}\n\n/* Enhanced table specific hover effects */\n.table-row:hover .group .group-hover\\\\:opacity-100 {\n  opacity: 1;\n  transform: translateX(2px);\n}\n\n.table-row:hover .btn-icon {\n  transform: translateX(2px);\n}\n\n.table-row:hover .category-color-dot {\n  transform: scale(1.1);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.table-row:hover .badge {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Row selection enhancement */\n.table-row.selected {\n  background: linear-gradient(90deg, var(--primary-25) 0%, var(--surface-primary) 100%);\n  border-left: 3px solid var(--primary-500);\n}\n\n.table-row.selected:hover {\n  background: linear-gradient(90deg, var(--primary-50) 0%, var(--gray-50) 100%);\n}\n\n/* ========================== */\n/* MOBILE RESPONSIVENESS ENHANCEMENTS */\n/* ========================== */\n\n/* Mobile-first breakpoints */\n/* Small mobile: 320px - 479px */\n/* Large mobile: 480px - 767px */\n/* Tablet: 768px - 1023px */\n/* Desktop: 1024px+ */\n\n/* Mobile Base Styles */\n@media (max-width: 767px) {\n  /* Enhanced mobile container */\n  .page-content {\n    padding: var(--space-3) var(--space-2);\n  }\n  \n  /* Mobile card styling */\n  .card {\n    margin-bottom: var(--space-4);\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-sm);\n  }\n  \n  .card-body {\n    padding: var(--space-3);\n  }\n  \n  /* Mobile transaction card */\n  .transaction-card {\n    padding: 0;\n    margin-bottom: var(--space-3);\n  }\n  \n  /* Mobile table responsive wrapper */\n  .table-responsive {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n    scrollbar-color: var(--gray-300) transparent;\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-sm);\n    position: relative;\n  }\n  \n  /* Show scroll hint on mobile */\n  .table-responsive::after {\n    content: '← Swipe to see all columns →';\n    position: absolute;\n    bottom: 4px;\n    right: 8px;\n    background: rgba(59, 130, 246, 0.9);\n    color: white;\n    padding: 2px 8px;\n    border-radius: var(--radius-sm);\n    font-size: 0.625rem;\n    font-weight: 500;\n    pointer-events: none;\n    z-index: 10;\n    opacity: 0.8;\n    animation: fadeInOut 6s ease-in-out;\n    animation-fill-mode: forwards;\n  }\n  \n  /* Hide hint when scrolling */\n  .table-responsive.scrolling::after {\n    display: none;\n  }\n  \n  .table-responsive::-webkit-scrollbar {\n    height: 6px;\n  }\n  \n  .table-responsive::-webkit-scrollbar-track {\n    background: var(--gray-100);\n    border-radius: var(--radius-sm);\n  }\n  \n  .table-responsive::-webkit-scrollbar-thumb {\n    background: var(--gray-300);\n    border-radius: var(--radius-sm);\n  }\n  \n  .table-responsive::-webkit-scrollbar-thumb:hover {\n    background: var(--gray-400);\n  }\n  \n  /* Mobile data table */\n  .data-table {\n    min-width: 820px; /* Ensure table doesn't collapse */\n    font-size: 0.8125rem; /* Slightly smaller for mobile */\n    table-layout: fixed;\n  }\n  \n  /* Mobile table header */\n  .table-header {\n    position: sticky;\n    top: 0;\n    z-index: 15;\n    background: var(--gradient-subtle);\n    backdrop-filter: blur(10px);\n    border-bottom: 2px solid var(--border-medium);\n  }\n  \n  .table-header-cell {\n    padding: var(--space-2) var(--space-3);\n    font-size: 0.6875rem;\n    font-weight: 600;\n    height: 44px;\n    vertical-align: middle;\n    white-space: nowrap;\n  }\n  \n  /* Mobile table body */\n  .table-body {\n    position: relative;\n  }\n  \n  /* Mobile table rows - Touch-friendly */\n  .table-row {\n    min-height: 52px;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    border-bottom: 1px solid var(--border-light);\n  }\n  \n  .table-row:hover {\n    background-color: var(--gray-50);\n    box-shadow: 0 1px 4px rgba(16, 24, 40, 0.06);\n    transform: none; /* Remove desktop hover transform on mobile */\n  }\n  \n  .table-row.selected {\n    background: linear-gradient(90deg, var(--primary-25) 0%, var(--surface-primary) 100%);\n    border-left: 4px solid var(--primary-500);\n  }\n  \n  .table-row.selected:hover {\n    background: linear-gradient(90deg, var(--primary-50) 0%, var(--gray-50) 100%);\n  }\n  \n  /* Mobile table cells - Touch-friendly */\n  .table-cell {\n    padding: var(--space-2) var(--space-3);\n    font-size: 0.8125rem;\n    line-height: 1.4;\n    height: 52px;\n    vertical-align: middle;\n    white-space: nowrap;\n  }\n  \n  /* Mobile-specific cell adjustments */\n  .table-cell input,\n  .table-cell select {\n    padding: var(--space-2);\n    font-size: 0.8125rem;\n    min-height: 36px; /* Touch-friendly minimum */\n  }\n  \n  /* Mobile checkbox styling - Touch-friendly */\n  .table-row input[type=\"checkbox\"],\n  .table-header-cell input[type=\"checkbox\"] {\n    width: 1.125rem;\n    height: 1.125rem;\n    min-width: 1.125rem;\n    min-height: 1.125rem;\n    border: 2px solid var(--border-medium);\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  \n  .table-row input[type=\"checkbox\"]:hover,\n  .table-header-cell input[type=\"checkbox\"]:hover {\n    border-color: var(--primary-400);\n    background-color: var(--primary-25);\n    transform: scale(1.1);\n  }\n  \n  .table-row input[type=\"checkbox\"]:checked,\n  .table-header-cell input[type=\"checkbox\"]:checked {\n    background-color: var(--primary-600);\n    border-color: var(--primary-600);\n  }\n  \n  /* Mobile editable cells - Touch-friendly */\n  .editable-cell {\n    cursor: pointer;\n    border-radius: var(--radius-sm);\n    margin: 1px;\n    min-height: 44px; /* Touch-friendly minimum */\n    display: flex;\n    align-items: center;\n  }\n  \n  .editable-cell:hover {\n    background-color: var(--gray-100);\n    transform: none; /* Remove desktop transform */\n    box-shadow: inset 2px 0 0 var(--primary-300);\n  }\n  \n  .editable-cell.editing {\n    background-color: var(--primary-50);\n    box-shadow: inset 0 0 0 2px var(--primary-400);\n    border-radius: var(--radius-md);\n    z-index: 20;\n  }\n  \n  .editable-content {\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: var(--space-1);\n  }\n  \n  /* Mobile button styles - Touch-friendly */\n  .btn {\n    min-height: 44px;\n    padding: var(--space-2) var(--space-4);\n    font-size: 0.875rem;\n    border-radius: var(--radius-md);\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  \n  .btn:hover {\n    transform: translateY(-1px);\n    box-shadow: var(--shadow-md);\n  }\n  \n  .btn:active {\n    transform: translateY(0);\n    box-shadow: var(--shadow-sm);\n  }\n  \n  .btn-sm {\n    min-height: 36px;\n    padding: var(--space-1) var(--space-3);\n    font-size: 0.75rem;\n  }\n  \n  /* Mobile icon buttons - Touch-friendly */\n  .btn-icon {\n    min-width: 44px;\n    min-height: 44px;\n    padding: var(--space-2);\n    border-radius: var(--radius-md);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  \n  .btn-icon:hover {\n    background-color: var(--gray-100);\n    transform: scale(1.05);\n    box-shadow: 0 2px 4px rgba(16, 24, 40, 0.1);\n  }\n  \n  .btn-icon:active {\n    transform: scale(0.98);\n  }\n  \n  .btn-edit:hover {\n    background-color: var(--primary-50);\n    color: var(--primary-700);\n  }\n  \n  .btn-delete:hover {\n    background-color: var(--danger-50);\n    color: var(--danger-700);\n  }\n  \n  /* Mobile badges - Touch-friendly */\n  .badge {\n    min-height: 24px;\n    padding: var(--space-1) var(--space-2);\n    font-size: 0.6875rem;\n    font-weight: 500;\n    border-radius: var(--radius-full);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    white-space: nowrap;\n  }\n  \n  .badge.cursor-pointer {\n    min-height: 32px;\n    padding: var(--space-1) var(--space-3);\n    cursor: pointer;\n  }\n  \n  .badge.cursor-pointer:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(16, 24, 40, 0.12);\n  }\n  \n  .badge.cursor-pointer:active {\n    transform: translateY(0);\n  }\n  \n  /* Mobile form controls - Touch-friendly */\n  .form-control {\n    min-height: 44px;\n    padding: var(--space-3);\n    font-size: 0.875rem;\n    border-radius: var(--radius-md);\n    border: 2px solid var(--border-medium);\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  \n  .form-control:focus {\n    border-color: var(--primary-500);\n    box-shadow: var(--focus-ring);\n    transform: translateY(-1px);\n  }\n  \n  .form-control::placeholder {\n    color: var(--gray-400);\n    font-size: 0.875rem;\n  }\n  \n  /* Mobile GL Account search */\n  .gl-account-search-wrapper {\n    position: relative;\n    z-index: 25;\n  }\n  \n  .table-gl-search {\n    min-height: 44px;\n    font-size: 0.875rem;\n    border-radius: var(--radius-md);\n    border: 2px solid var(--primary-400);\n    box-shadow: var(--shadow-sm);\n  }\n  \n  .table-gl-search:focus {\n    border-color: var(--primary-500);\n    box-shadow: var(--focus-ring);\n  }\n\n  /* Modal responsiveness */\n  .modal-content {\n    margin: var(--space-4);\n    max-height: calc(100vh - 2rem);\n  }\n\n  .modal-body {\n    max-height: calc(70vh - 200px);\n    padding: var(--space-4);\n  }\n\n  .modal-header,\n  .modal-footer {\n    padding: var(--space-4);\n  }\n  \n  .edit-actions {\n    margin-top: var(--space-3);\n    display: flex;\n    gap: var(--space-2);\n    justify-content: flex-end;\n  }\n  \n  .edit-actions .btn-sm {\n    min-height: 36px;\n    padding: var(--space-2) var(--space-3);\n  }\n  \n  /* Mobile amount input group */\n  .amount-input-group {\n    display: flex;\n    align-items: center;\n    gap: var(--space-2);\n  }\n  \n  .amount-input-group select {\n    min-height: 44px;\n    min-width: 70px;\n    padding: var(--space-2);\n    border-radius: var(--radius-md);\n  }\n  \n  .amount-input-group input {\n    min-height: 44px;\n    flex: 1;\n    padding: var(--space-2) var(--space-3);\n    border-radius: var(--radius-md);\n  }\n  \n  /* Mobile category display */\n  .category-display {\n    display: flex;\n    align-items: center;\n    gap: var(--space-2);\n    min-height: 44px;\n  }\n  \n  .category-color-dot {\n    width: 0.875rem;\n    height: 0.875rem;\n    border-radius: 50%;\n    flex-shrink: 0;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  \n  .category-display:hover .category-color-dot {\n    transform: scale(1.15);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n  \n  /* Mobile actions cell */\n  .actions-cell {\n    width: 100px;\n    text-align: center;\n  }\n  \n  .actions-cell .flex {\n    justify-content: center;\n    align-items: center;\n    gap: var(--space-2);\n  }\n  \n  /* Mobile bulk actions */\n  .bulk-actions {\n    margin-bottom: var(--space-3);\n    padding: var(--space-3);\n    border-radius: var(--radius-md);\n    background: var(--gradient-primary);\n    color: white;\n    box-shadow: var(--shadow-md);\n  }\n  \n  .bulk-actions .btn {\n    background: rgba(255, 255, 255, 0.2);\n    color: white;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    backdrop-filter: blur(10px);\n    min-height: 44px;\n  }\n  \n  .bulk-actions .btn:hover {\n    background: rgba(255, 255, 255, 0.3);\n    transform: translateY(-1px);\n  }\n  \n  /* Mobile modal optimizations */\n  .modal-container {\n    padding: var(--space-3);\n    align-items: flex-end;\n  }\n  \n  .modal-content {\n    border-radius: var(--radius-xl) var(--radius-xl) 0 0;\n    max-height: 80vh;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  \n  .modal-content > div {\n    padding: var(--space-4);\n  }\n  \n  /* Mobile search and filter optimization */\n  .search-input {\n    min-height: 44px;\n    padding: var(--space-3);\n    font-size: 0.875rem;\n    border-radius: var(--radius-md);\n  }\n  \n  .filter-controls {\n    gap: var(--space-3);\n  }\n  \n  .filter-group {\n    gap: var(--space-2);\n  }\n  \n  .date-input,\n  .status-select {\n    min-height: 44px;\n    padding: var(--space-2);\n    font-size: 0.875rem;\n    border-radius: var(--radius-md);\n  }\n  \n  /* Mobile category tags */\n  .category-tag {\n    min-height: 36px;\n    padding: var(--space-2) var(--space-3);\n    font-size: 0.75rem;\n    border-radius: var(--radius-full);\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  \n  .category-tag:hover {\n    transform: translateY(-1px);\n    box-shadow: var(--shadow-sm);\n  }\n  \n  .category-tag:active {\n    transform: translateY(0);\n  }\n  \n  /* Mobile loading states */\n  .loading-spinner {\n    width: 1.25rem;\n    height: 1.25rem;\n    border-width: 2px;\n  }\n  \n  .loading-spinner-sm {\n    width: 1rem;\n    height: 1rem;\n    border-width: 2px;\n  }\n  \n  .loading-spinner-lg {\n    width: 1.75rem;\n    height: 1.75rem;\n    border-width: 3px;\n  }\n  \n  /* Mobile hover state optimizations */\n  .table-row:hover .group .group-hover\\\\:opacity-100 {\n    opacity: 1;\n  }\n  \n  .table-row:hover .btn-icon {\n    transform: none; /* Remove desktop transform */\n  }\n  \n  /* Mobile focus states */\n  .table-row:focus-within {\n    background-color: var(--primary-25);\n    box-shadow: inset 0 0 0 2px var(--primary-200);\n  }\n  \n  .editable-cell:focus-within {\n    background-color: var(--primary-50);\n    box-shadow: inset 0 0 0 2px var(--primary-300);\n  }\n  \n  /* Mobile typography adjustments */\n  .page-title {\n    font-size: 1.25rem;\n    font-weight: 700;\n    margin-bottom: var(--space-3);\n  }\n  \n  .filter-title {\n    font-size: 1rem;\n    font-weight: 600;\n  }\n  \n  .filter-badge {\n    height: 1.125rem;\n    min-width: 1.125rem;\n    font-size: 0.6875rem;\n    font-weight: 600;\n  }\n  \n  /* Mobile error and success states */\n  .error-message,\n  .success-message {\n    font-size: 0.75rem;\n    margin-top: var(--space-1);\n    padding: var(--space-1);\n    border-radius: var(--radius-sm);\n  }\n  \n  .error-message {\n    background-color: var(--danger-50);\n    color: var(--danger-700);\n    border: 1px solid var(--danger-200);\n  }\n  \n  .success-message {\n    background-color: var(--success-50);\n    color: var(--success-700);\n    border: 1px solid var(--success-200);\n  }\n}\n\n/* Large Mobile Styles (480px - 767px) */\n@media (min-width: 480px) and (max-width: 767px) {\n  .page-content {\n    padding: var(--space-4) var(--space-3);\n  }\n  \n  .card-body {\n    padding: var(--space-4);\n  }\n  \n  .table-header-cell {\n    padding: var(--space-3) var(--space-4);\n    font-size: 0.75rem;\n    height: 48px;\n  }\n  \n  .table-cell {\n    padding: var(--space-3) var(--space-4);\n    font-size: 0.875rem;\n    height: 56px;\n  }\n  \n  .data-table {\n    min-width: 820px;\n    font-size: 0.875rem;\n    table-layout: fixed;\n  }\n  \n  .btn-icon {\n    min-width: 40px;\n    min-height: 40px;\n    padding: var(--space-2);\n  }\n  \n  .form-control {\n    min-height: 48px;\n    padding: var(--space-3) var(--space-4);\n  }\n  \n  .badge {\n    min-height: 28px;\n    padding: var(--space-1) var(--space-3);\n    font-size: 0.75rem;\n  }\n  \n  .page-title {\n    font-size: 1.375rem;\n  }\n}\n\n/* Tablet Styles (768px - 1023px) */\n@media (min-width: 768px) and (max-width: 1023px) {\n  .page-content {\n    padding: var(--space-5) var(--space-4);\n  }\n  \n  .table-responsive {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  \n  .data-table {\n    min-width: 1100px;\n  }\n  \n  .table-header-cell {\n    height: 50px;\n    padding: var(--space-3) var(--space-4);\n    font-size: 0.75rem;\n  }\n  \n  .table-cell {\n    height: 58px;\n    padding: var(--space-3) var(--space-4);\n    font-size: 0.875rem;\n  }\n  \n  .btn-icon {\n    min-width: 36px;\n    min-height: 36px;\n  }\n  \n  .form-control {\n    min-height: 44px;\n  }\n  \n  .modal-container {\n    padding: var(--space-4);\n    align-items: center;\n  }\n  \n  .modal-content {\n    border-radius: var(--radius-xl);\n    max-height: 90vh;\n  }\n}\n\n/* Desktop Styles (1024px+) - Maintain existing desktop experience */\n@media (min-width: 1024px) {\n  .table-responsive {\n    overflow-x: auto; /* Allow scrolling if needed even on desktop */\n  }\n  \n  .table-responsive::after {\n    display: none;\n  }\n  \n  .data-table {\n    min-width: 820px;\n    table-layout: fixed;\n  }\n  \n  /* Restore original desktop hover effects */\n  .table-row:hover {\n    background-color: var(--gray-50);\n    transform: translateY(-1px);\n    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.08), 0 1px 3px rgba(16, 24, 40, 0.12);\n  }\n  \n  .editable-cell:hover {\n    background-color: var(--gray-100);\n    transform: translateX(2px);\n    box-shadow: inset 3px 0 0 var(--primary-300), 0 2px 4px rgba(16, 24, 40, 0.08);\n  }\n  \n  .table-row:hover .group .group-hover\\\\:opacity-100 {\n    opacity: 1;\n    transform: translateX(2px);\n  }\n  \n  .table-row:hover .btn-icon {\n    transform: translateX(2px);\n  }\n}\n\n/* Touch device optimizations */\n@media (hover: none) and (pointer: coarse) {\n  /* Remove hover effects on touch devices */\n  .table-row:hover {\n    background-color: var(--surface-primary);\n    transform: none;\n    box-shadow: none;\n  }\n  \n  .editable-cell:hover {\n    background-color: var(--surface-primary);\n    transform: none;\n    box-shadow: none;\n  }\n  \n  .btn:hover {\n    transform: none;\n    box-shadow: var(--shadow-sm);\n  }\n  \n  .btn-icon:hover {\n    transform: none;\n    background-color: var(--surface-primary);\n  }\n  \n  .badge:hover {\n    transform: none;\n  }\n  \n  .category-tag:hover {\n    transform: none;\n  }\n  \n  /* Enhanced touch feedback */\n  .table-row:active {\n    background-color: var(--gray-100);\n    transform: scale(0.99);\n  }\n  \n  .editable-cell:active {\n    background-color: var(--primary-100);\n    transform: scale(0.98);\n  }\n  \n  .btn:active {\n    transform: scale(0.96);\n  }\n  \n  .btn-icon:active {\n    transform: scale(0.92);\n    background-color: var(--gray-100);\n  }\n  \n  .badge:active {\n    transform: scale(0.95);\n  }\n}\n\n/* High DPI screen optimizations */\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  .table-responsive::-webkit-scrollbar {\n    height: 8px;\n  }\n  \n  .table-row input[type=\"checkbox\"],\n  .table-header-cell input[type=\"checkbox\"] {\n    border-width: 1px;\n  }\n  \n  .loading-spinner {\n    border-width: 1px;\n  }\n  \n  .loading-spinner-sm {\n    border-width: 1px;\n  }\n  \n  .loading-spinner-lg {\n    border-width: 2px;\n  }\n}\n\n/* Landscape phone optimizations */\n@media (max-width: 767px) and (orientation: landscape) {\n  .page-content {\n    padding: var(--space-2) var(--space-3);\n  }\n  \n  .table-header-cell {\n    height: 40px;\n    padding: var(--space-2) var(--space-3);\n    font-size: 0.6875rem;\n  }\n  \n  .table-cell {\n    height: 48px;\n    padding: var(--space-2) var(--space-3);\n    font-size: 0.8125rem;\n  }\n  \n  .btn {\n    min-height: 36px;\n    padding: var(--space-2) var(--space-3);\n  }\n  \n  .btn-icon {\n    min-width: 36px;\n    min-height: 36px;\n    padding: var(--space-1);\n  }\n  \n  .form-control {\n    min-height: 36px;\n    padding: var(--space-2) var(--space-3);\n  }\n  \n  .modal-content {\n    max-height: 70vh;\n  }\n}\n\n/* Small screen optimizations for very small devices */\n@media (max-width: 320px) {\n  .page-content {\n    padding: var(--space-2) var(--space-1);\n  }\n  \n  .data-table {\n    min-width: 800px;\n    font-size: 0.75rem;\n  }\n  \n  .table-header-cell {\n    padding: var(--space-1) var(--space-2);\n    font-size: 0.625rem;\n    height: 40px;\n  }\n  \n  .table-cell {\n    padding: var(--space-1) var(--space-2);\n    font-size: 0.75rem;\n    height: 48px;\n  }\n  \n  .btn {\n    min-height: 40px;\n    padding: var(--space-2) var(--space-3);\n    font-size: 0.8125rem;\n  }\n  \n  .btn-sm {\n    min-height: 32px;\n    padding: var(--space-1) var(--space-2);\n    font-size: 0.6875rem;\n  }\n  \n  .btn-icon {\n    min-width: 40px;\n    min-height: 40px;\n    padding: var(--space-1);\n  }\n  \n  .form-control {\n    min-height: 40px;\n    padding: var(--space-2);\n    font-size: 0.8125rem;\n  }\n  \n  .badge {\n    min-height: 20px;\n    padding: var(--space-1) var(--space-2);\n    font-size: 0.625rem;\n  }\n  \n  .page-title {\n    font-size: 1.125rem;\n  }\n}\n\n/* Dark mode mobile optimizations */\n@media (prefers-color-scheme: dark) {\n  @media (max-width: 767px) {\n    .table-responsive::-webkit-scrollbar-track {\n      background: var(--gray-800);\n    }\n    \n    .table-responsive::-webkit-scrollbar-thumb {\n      background: var(--gray-600);\n    }\n    \n    .table-responsive::-webkit-scrollbar-thumb:hover {\n      background: var(--gray-500);\n    }\n    \n    .table-row:hover {\n      background-color: var(--gray-800);\n    }\n    \n    .editable-cell:hover {\n      background-color: var(--gray-700);\n    }\n    \n    .btn-icon:hover {\n      background-color: var(--gray-800);\n    }\n    \n    .form-control {\n      background-color: var(--gray-900);\n      border-color: var(--gray-700);\n      color: var(--gray-100);\n    }\n    \n    .form-control:focus {\n      border-color: var(--primary-400);\n      background-color: var(--gray-800);\n    }\n    \n    .modal-content {\n      background-color: var(--gray-900);\n      border-color: var(--gray-700);\n    }\n    \n    .error-message {\n      background-color: var(--danger-900);\n      color: var(--danger-300);\n      border-color: var(--danger-700);\n    }\n    \n    .success-message {\n      background-color: var(--success-900);\n      color: var(--success-300);\n      border-color: var(--success-700);\n    }\n  }\n}\n\n/* Accessibility improvements for mobile */\n@media (max-width: 767px) {\n  /* Focus indicators */\n  .table-row:focus-within {\n    outline: 2px solid var(--primary-500);\n    outline-offset: 2px;\n  }\n  \n  .editable-cell:focus-within {\n    outline: 2px solid var(--primary-500);\n    outline-offset: 1px;\n  }\n  \n  .btn:focus-visible {\n    outline: 2px solid var(--primary-500);\n    outline-offset: 2px;\n  }\n  \n  .form-control:focus-visible {\n    outline: 2px solid var(--primary-500);\n    outline-offset: 1px;\n  }\n  \n  /* Enhanced contrast for better visibility */\n  .table-row.selected {\n    border-left: 4px solid var(--primary-600);\n  }\n  \n  .badge {\n    border: 1px solid transparent;\n  }\n  \n  .badge-primary {\n    border-color: var(--primary-300);\n  }\n  \n  .badge-success {\n    border-color: var(--success-300);\n  }\n  \n  .badge-warning {\n    border-color: var(--warning-300);\n  }\n  \n  .badge-danger {\n    border-color: var(--danger-300);\n  }\n}\n\n/* Animation performance optimizations for mobile */\n@media (max-width: 767px) {\n  .table-row,\n  .editable-cell,\n  .btn,\n  .btn-icon,\n  .badge,\n  .form-control {\n    transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n  }\n  \n  /* Reduce animations on low-end devices */\n  @media (max-width: 479px) {\n    .table-row:hover {\n      transition: none;\n    }\n    \n    .editable-cell:hover {\n      transition: none;\n    }\n    \n    .btn:hover {\n      transition: none;\n    }\n  }\n}\n\n/* Swipe gesture indicators */\n@media (max-width: 767px) {\n  .table-responsive {\n    position: relative;\n  }\n  \n  .table-responsive::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 20px;\n    background: linear-gradient(to left, rgba(255, 255, 255, 0.8), transparent);\n    pointer-events: none;\n    z-index: 5;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n  }\n  \n  .table-responsive:hover::before {\n    opacity: 1;\n  }\n  \n  .table-responsive::after {\n    content: '→';\n    position: absolute;\n    top: 50%;\n    right: 8px;\n    transform: translateY(-50%);\n    color: var(--gray-400);\n    font-size: 0.875rem;\n    font-weight: 600;\n    pointer-events: none;\n    z-index: 6;\n    opacity: 0;\n    animation: fadeIn 0.3s ease 2s forwards;\n  }\n  \n  .table-responsive:hover::after {\n    opacity: 0;\n  }\n}\n\n/* Print optimizations */\n@media print {\n  .table-responsive {\n    overflow: visible;\n  }\n  \n  .data-table {\n    min-width: auto;\n    font-size: 0.75rem;\n  }\n  \n  .table-header-cell,\n  .table-cell {\n    padding: var(--space-1) var(--space-2);\n  }\n  \n  .btn-icon,\n  .btn,\n  .edit-actions {\n    display: none !important;\n  }\n  \n  .table-row:hover {\n    background-color: transparent;\n    transform: none;\n    box-shadow: none;\n  }\n  \n  .editable-cell:hover {\n    background-color: transparent;\n    transform: none;\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
